// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:07:39.250Z
// Property: Fox Pointe (ID: 6767906449166315)
// Collections: 27 amenities, 13 floorplans (live), 18 photos, 76 POIs, 3 reviews, 2 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166315",
  "property_external_id": "30938",
  "property_zillow_url": "https://www.zillow.com/apartments/hi-nella-nj/fox-pointe/5gjbNZ/",
  "property_apartments_url": "https://www.apartments.com/fox-pointe-hi-nella-nj/0k496m1/",
  "property_google_business_url": "https://www.google.com/maps/place/Fox+Pointe+Apartment+Homes/data=!4m2!3m1!1s0x0:0x92db5c2cf398c660?sa=X&ved=2ahUKEwjcwMqQmbiSAxUck2oFHfS_EHoQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "fox-pointe",
  "property_name": "Fox Pointe",
  "property_website_url": "https://www.livefoxpointe.com/",
  "property_domain": "https://www.livefoxpointe.com/",
  "property_address": "220 Dobbs Drive",
  "property_full_address": "220 Dobbs Dr, Hi-Nella, NJ 08083",
  "property_address_1": "220 Dobbs Dr",
  "property_address_2": null,
  "property_address_city": "Hi Nella",
  "property_address_state": "NJ",
  "property_address_zip_full": "08083-2908",
  "property_address_zip": "08083",
  "property_address_country": "US",
  "property_address_county": "Camden County",
  "property_neighborhood_address": "Lower Camden County",
  "property_address_latitude": "39.83412879999999",
  "property_address_longitude": "-75.0194944",
  "property_email": "foxpointe@aionmanagement.com",
  "property_phone": "(856) 784-5553",
  "property_call_tracking_phone": "833-683-4035",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Fox Pointe in Hi-Nella, NJ, your ideal home awaits with one to three-bedroom floor plans, stylish upgrades, and modern amenities. Enjoy a vibrant lifestyle with a fitness center, swimming pool, and community events. Pet-friendly and equipped with EV charging, this is more than an apartment—it's your sanctuary.",
  "property_long_description": "**Discover Your Perfect Home at Fox Pointe in Hi-Nella, NJ!**\n\nWelcome to Fox Pointe, where modern living meets comfort and convenience. Our thoughtfully designed apartment community offers an array of floor plans to suit your lifestyle, with spacious one, two, and three-bedroom options available. Whether you're looking for a cozy nook or a larger space to accommodate your needs, we have the right fit for you.\n\nAt Fox Pointe, we pride ourselves on our exceptional amenities that enhance your living experience. Enjoy peace of mind with our bilingual property team and 24-hour emergency maintenance, ensuring your needs are met promptly. Discover active living with our state-of-the-art fitness center, refreshing swimming pool, and inviting sundeck. Our community also features cozy grilling stations, a picnic area, and vibrant resident activities, perfect for fostering connections with your neighbors.\n\nOur apartments come equipped with modern upgrades such as stainless steel appliances, renovated kitchens and bathrooms, and stylish walnut and white cabinetry. Choose from first or second-floor units with private entrances, vinyl plank flooring, and full-size washer and dryer options to make life easier.\n\nFox Pointe is pet-friendly, offering ample on-site and off-street parking along with convenient EV charging stations. Plus, with flexible rent payment options via our online resident portal and short-term leases, we make moving in and settling down a breeze.\n\nDon’t wait any longer to make Fox Pointe your new home—browse our availability or schedule a tour today to experience everything our vibrant community has to offer!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-9d4b-739c-97d8-2786c9121cdf.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
    "public_id": "019fcdf4-9d4b-739c-97d8-2786c9121cdf",
    "storage_key": "property/6767906449166315/019fcdf4-9d4b-739c-97d8-2786c9121cdf.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "246",
  "property_year_built": "1968",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.34146341463415",
  "property_admin_fee": "100",
  "property_application_fee": "50",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Maximum 2 pets per apartment, each up to 100 lb. Breed restrictions apply.",
  "property_pet_policy_description": "Cats and dogs are welcome. Maximum 2 pets per apartment, each up to 100 lb. Breed restrictions apply. A $400 non‑refundable fee is required. Monthly pet rent is $50 for one pet and $75 for two pets.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://foxpointe.loftliving.com/login",
  "property_apply_now_url": "https://www.livefoxpointe.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0267-518b-73fd-942a-323167fdbc36.webp",
  "property_primary_logo_media": {
    "alt_text": "Fox Pointe Apartment Homes logo",
    "public_id": "019d0267-518b-73fd-942a-323167fdbc36",
    "storage_key": "property/6767906449166315/019d0267-518b-73fd-942a-323167fdbc36.webp",
    "width": 340,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0264-88a5-76f8-9767-457ebd450550.webp",
  "property_secondary_logo_media": {
    "alt_text": "Fox Pointe Apartment Homes logo",
    "public_id": "019d0264-88a5-76f8-9767-457ebd450550",
    "storage_key": "property/6767906449166315/019d0264-88a5-76f8-9767-457ebd450550.webp",
    "width": 340,
    "height": 160
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0264-86bb-708b-82f9-9c4f291b9f54.webp",
  "property_icon_media": {
    "alt_text": "F logo",
    "public_id": "019d0264-86bb-708b-82f9-9c4f291b9f54",
    "storage_key": "property/6767906449166315/019d0264-86bb-708b-82f9-9c4f291b9f54.webp",
    "width": 600,
    "height": 600
  },
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0267-49d4-72ca-a60e-cfc09681beb5.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Fox Pointe Apartment Homes logo",
    "public_id": "019d0267-49d4-72ca-a60e-cfc09681beb5",
    "storage_key": "property/6767906449166315/019d0267-49d4-72ca-a60e-cfc09681beb5.webp",
    "width": 340,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0267-518b-73fd-942a-323167fdbc36.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Fox Pointe Apartment Homes logo",
    "public_id": "019d0267-518b-73fd-942a-323167fdbc36",
    "storage_key": "property/6767906449166315/019d0267-518b-73fd-942a-323167fdbc36.webp",
    "width": 340,
    "height": 160
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1.5",
  "property_sqft_range": "662 - 1016",
  "property_sqft_min": "662",
  "property_sqft_max": "1016",
  "property_price_range": "1427 - 2122",
  "property_price_min": "1427",
  "property_price_max": "2122",
  "property_available_units": 9,
  "property_facebook_url": "https://facebook.com/LiveFoxPointe/reels/",
  "property_instagram_url": "https://instagram.com/foxpointeapartments/",
  "property_twitter_url": "https://www.twitter.com/livefoxpointe",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJK3hyq57NxokRYMaY8yxc25I",
  "property_youtube_url": null,
  "property_yelp_url": "https://m.yelp.com/search?find_desc=Apartments&find_loc=Barrington%2C+NJ",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Fox Pointe",
  "property_home_romance_title": "Embrace the Joy of Living in Your Dream Apartment Community",
  "property_home_amenities_blurb": "Welcome to Fox Pointe in charming Hi-Nella, NJ! Our diverse floor plans, including one to three-bedroom options, are designed for modern living. Enjoy pet-friendly perks, from a sparkling swimming pool and fitness center to cozy grilling stations. Elevate your lifestyle with our top-notch amenities and contemporary finishes. Join our vibrant community today!",
  "property_home_floorplans_blurb": "Welcome to Fox Pointe in Hi-Nella, NJ, where comfort meets style. Choose from our thoughtfully designed one, two, and three-bedroom apartment homes, each curated to fit your lifestyle. Ready to elevate your living experience? Browse our available floor plans today and find the perfect space to call home!",
  "property_home_gallery_blurb": "Welcome to Fox Pointe in Hi-Nella, NJ, where comfort meets style. Choose from our one, two, or three-bedroom apartments featuring modern upgrades, pet-friendly policies, and vibrant community activities. Enjoy amenities like a refreshing pool, fitness center, and EV charging stations. Picture yourself living here, embracing a lifestyle of convenience and relaxation!",
  "property_home_neighborhood_blurb": "Welcome to Fox Pointe, your tranquil haven in Hi-Nella, NJ, surrounded by vibrant parks, top-notch schools, and cultural hotspots. Experience the charm of community life just minutes from Camden County College, Adventure Aquarium, and serene natural escapes like Newton Lake Park. Uncover the perfect blend of comfort and convenience!",
  "property_home_reviews_blurb": "At Fox Pointe in Hi-Nella, NJ, our residents rave about the sense of community and attentive staff. \"It feels like home,\" says one happy tenant, highlighting our team's seamless support during the move-in process. Experience stress-free living where every question is answered with patience and care. Join us today!",
  "property_neighborhood_blurb": "Nestled in the vibrant Hi-Nella, NJ, Fox Pointe offers more than just stylish one, two, and three-bedroom apartments. Immerse yourself in local culture with parks like Cooper River Park, thrilling adventures at Clementon Park & Splash World, and enriching experiences at Camden County College. Find your perfect balance of comfort and community!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Fox Pointe in Hi-Nella, NJ, your perfect home awaits with spacious one, two, and three-bedroom floor plans. Enjoy modern comforts like stainless steel appliances and pet-friendly spaces, all enhanced by exceptional amenities. Join our vibrant community where relaxation meets convenience, tailored just for you. Your new lifestyle begins here!",
  "property_applynow_blurb": "At Fox Pointe in Hi-Nella, NJ, our diverse floor plans—ranging from one to three bedrooms—cater to every lifestyle. Enjoy exceptional amenities like a resident activities program, a fitness center, and a refreshing swimming pool, all while basking in your pet-friendly haven. Lease your dream apartment online today!",
  "property_contactus_blurb": "At Fox Pointe in Hi-Nella, NJ, find the perfect living space tailored to your lifestyle. Choose from our spacious one, two, and three-bedroom floor plans designed for comfort and convenience. Have questions? Contact our leasing team today to learn more and take the first step toward your new home!",
  "property_faqs_blurb": "At Fox Pointe in Hi-Nella, NJ, our diverse floor plans—ranging from cozy one-bedroom to spacious three-bedroom apartments—cater to every lifestyle. Curious about our community? Browse our FAQs page for insightful answers to questions that matter, ensuring you find the perfect fit for your next home.",
  "property_floorplans_blurb": "At Fox Pointe in Hi-Nella, NJ, your ideal living space awaits! Choose from thoughtfully designed one, two, or three-bedroom floor plans that blend comfort and style. Each layout invites you to create a home uniquely yours. Browse our available apartment homes today and find the perfect fit!",
  "property_gallery_blurb": "At Fox Pointe in Hi-Nella, NJ, our vibrant community radiates warmth and connection. Imagine relaxing by the swimming pool, joining engaging resident activities, or unwinding in your beautifully renovated apartment. With choices from one to three bedrooms and top-notch amenities ready to enhance your lifestyle, picture yourself living here!",
  "property_interactivemap_blurb": "At Fox Pointe in Hi-Nella, NJ, your perfect home awaits. Choose from stylish one, two, or three-bedroom floor plans, all enhanced by top-notch amenities like a refreshing swimming pool, fitness center, and resident activities. Check out our interactive community map for available apartments and pricing today!",
  "property_pets_blurb": "At Fox Pointe in Hi-Nella, NJ, your furry friends can thrive with you! Enjoy spacious living alongside your cats and dogs (up to 100 lbs). With a nurturing pet policy and nearby green spaces, it's the perfect community for both you and your pets to create lasting memories together.",
  "property_referafriend_blurb": "At Fox Pointe in Hi-Nella, NJ, great friends make great neighbors! Choose from spacious one, two, or three-bedroom floor plans that cater to your lifestyle. Share the warmth of our vibrant community—refer a friend today and enjoy the benefits of wonderful companionship in your new home! ",
  "property_residentaccess_blurb": "Welcome to Fox Pointe in Hi-Nella, NJ, where your perfect home awaits. Choose from spacious one, two, or three-bedroom floor plans that fit your lifestyle. Access your resident portal effortlessly to manage rent payments, schedule maintenance, and enjoy a seamless living experience. Your comfort is our priority!",
  "property_reviews_blurb": "At Fox Pointe in Hi-Nella, NJ, our residents rave about their seamless living experiences, stating, “Fox Pointe feels like home.” With a dedicated staff that goes above and beyond, including Terik and John, you can trust that questions will be answered with patience and care. Join our community today!",
  "property_created_at": "1757005056905",
  "property_scheduletour_blurb": "At Fox Pointe in Hi-Nella, NJ, find your ideal home among our thoughtfully designed one, two, and three-bedroom floor plans. Experience community living like never before—hear firsthand from our residents about why they love calling Fox Pointe home. Schedule your tour today and step into your future!",
  "property_thankyou_blurb": "Thank you for your interest in Fox Pointe! Nestled in charming Hi-Nella, NJ, our diverse floor plans—ranging from one to three bedrooms—offer the perfect blend of comfort and style. A team member will reach out soon to help you find your ideal home. Stay tuned for an exciting journey ahead!",
  "property_virtualtours_blurb": "Welcome to Fox Pointe in Hi-Nella, NJ, where comfort meets style. Our thoughtfully designed one, two, and three-bedroom apartments offer spacious living tailored to your needs. Experience the vibrant community and stunning interiors—take a virtual tour today to envision your new home!",
  "property_copyright": "2025 All Rights Reserved. Fox Pointe",
  "property_seo_title_home": "Fox Pointe |  Apartments in Hi-Nella, NJ",
  "property_seo_description_home": "Experience modern living at Fox Pointe in Hi-Nella, NJ. Choose from spacious one to three-bedroom homes with premium amenities. Find your new sanctuary today!",
  "property_seo_title_floorplans": "Floor Plans | Hi-Nella, NJ Apartments for Rent",
  "property_seo_description_floorplans": "Find your perfect match at Fox Pointe in Hi-Nella, NJ. Choose from stylish one, two, and three-bedroom floor plans designed for modern living. Browse today!",
  "property_seo_title_amenities": "Amenities | Hi-Nella, NJ Apartments for Rent",
  "property_seo_description_amenities": "Discover comfort at Fox Pointe in Hi-Nella! Enjoy stunning amenities, including a pool, fitness center, and pet-friendly perks. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Hi-Nella, NJ",
  "property_seo_description_gallery": "Imagine life at Fox Pointe in Hi-Nella, NJ! Spacious floor plans, modern amenities, and a vibrant community await. Picture yourself here today!",
  "property_seo_title_virtualtours": "Virtual Tours | Fox Pointe Apartments",
  "property_seo_description_virtualtours": "Step inside Fox Pointe in Hi-Nella, NJ! Experience our stunning one, two, and three-bedroom floor plans. Take a virtual tour and envision your new home today!",
  "property_seo_title_interactivemap": "Interactive Map | Fox Pointe Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Fox Pointe in Hi-Nella, NJ! Use our interactive map to explore pet-friendly apartments with top-notch amenities and modern upgrades.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Hi-Nella, NJ",
  "property_seo_description_neighborhood": "Uncover the charm of Hi-Nella at Fox Pointe. From parks to dining, dive into local favorites and discover the vibrant community surrounding your new home!",
  "property_seo_title_contact": "Contact Us | Fox Pointe",
  "property_seo_description_contact": "Discover comfort at Fox Pointe in Hi-Nella, NJ. Cozy one-beds to spacious three-beds await. Contact our leasing team with any questions!",
  "property_seo_title_faqs": "FAQs | Apartments in Hi-Nella, NJ",
  "property_seo_description_faqs": "Find answers to your top questions about Fox Pointe in Hi-Nella, NJ! Explore our amenities, floor plans, and community details—all at your fingertips!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Hi-Nella, NJ",
  "property_seo_description_reviews": "At Fox Pointe in Hi-Nella, NJ, hear from our residents about community life, premium amenities, and the joy of calling this place home! Join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Hi-Nella, NJ",
  "property_seo_description_applynow": "Experience life at Fox Pointe in Hi-Nella, NJ! Choose from stylish one to three-bedroom apartments with top-notch amenities. Your new home awaits—apply online!",
  "property_seo_title_residentaccess": "Resident Access | Fox Pointe",
  "property_seo_description_residentaccess": "Log in to the Fox Pointe resident portal in Hi-Nella, NJ, to manage rent, request maintenance, and stay connected with your community—all in one place!",
  "property_seo_title_referafriend": "Refer A Friend | Fox Pointe",
  "property_seo_description_referafriend": "Refer a friend to Fox Pointe in Hi-Nella, NJ! Share the joy of great living with your favorite people—because great friends make the best neighbors!",
  "property_seo_title_scheduletour": "Schedule a Tour | Fox Pointe",
  "property_seo_description_scheduletour": "Experience the charm of Fox Pointe in Hi-Nella, NJ. Schedule a tour today and envision your new home in our vibrant community! Your dream apartment awaits.",
  "property_seo_title_privacy": "Privacy Policy | Fox Pointe",
  "property_seo_description_privacy": "At Fox Pointe in Hi-Nella, NJ, your privacy matters. Learn how we protect your information and ensure a secure community. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Fox Pointe",
  "property_seo_description_accessibility": "At Fox Pointe in Hi-Nella, NJ, we prioritize digital inclusion and accessibility for all. Join our community where everyone feels at home.",
  "property_seo_title_sitemap": "Sitemap | Fox Pointe",
  "property_seo_description_sitemap": "Uncover the layout of Fox Pointe in Hi-Nella, NJ! Navigate our sitemap for a seamless journey to your dream apartment and community amenities.",
  "property_seo_title_thankyou": "Thank You | Fox Pointe",
  "property_seo_description_thankyou": "Thank you for your interest in Fox Pointe! A team member will reach out soon to help you find your perfect home in Hi-Nella, NJ. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Hi-Nella, NJ",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293651129",
  "amenities": [
    {
      "id": "custom_edd4a400-2697-4644-968b-96cc28d533c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_99742fa0-382d-4ab4-98f5-c8e9ae88d51b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Bilingual Site Team",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3a2a8b1a-1437-4ae9-8291-f346a956ea28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_709e5490-afdb-4798-8c47-80c577bad0cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8f793a4d-635f-408f-b367-772e664884ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment & Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bf39b386-cce2-43c6-9558-c6cc66111496",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Laundry Facility",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9b47a176-bac8-4fa5-beea-d638b1e68471",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a0f93629-722f-485c-a7a1-7f52b4da330b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ad285cb4-97e0-49f8-b5f5-98db2407ba33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_42a5fbfc-7534-411a-997c-9b3e0dca309c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e1bd083d-ea17-4247-be8f-6afda1071b5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Cable-Ready",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9c5ec041-8042-4ec0-a3a0-cd47a3e9fd55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_09ecb58d-f4c0-4939-a11c-678025cd6278",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Garbage Disposal*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_31f69e23-09af-4db6-af27-2a53ad364ba2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Gas Stove, Heating & Cooking",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_48b1e5a7-e1ea-4e2c-b1b6-6dff15d6efaf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bb5df1ba-e4df-460a-8667-6ae225f0bcfa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Pantry*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f70d12e5-1e1a-40c7-b8fc-c2347a60a98f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Private Apartment Entrances",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8bad33d4-8324-418b-8533-edd47d897386",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio or Balcony",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3c76b6e3-e57b-4fff-8256-621f861c6450",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Upgraded Kitchens & Bathrooms*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ead5139e-f98d-4110-be2a-fefe72c340c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ecb9bd80-172e-4018-a433-41dd04776200",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Wood Plank Kitchen Flooring*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8a942dc5-8899-4a1e-8074-f5346e384d2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Landscaped Grounds",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5f7c0b6f-3243-4480-8cb3-87efd8e746c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "EV Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0f22e670-f6df-48c1-bbe5-bd72e940ae40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling and Picnic Area*",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_97d8c179-6d7c-4453-8d39-116052980395",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Off-Street Parking",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_04084d4b-f6b5-49f0-b8cc-57b753997332",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3ea28ce7-96aa-41f6-b178-769db9d93db1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_a26d4fd3-85ab-4471-99b6-be1dad4b9bfb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-b47d-76ec-8932-2c7f1db9bc98.webp",
      "image_media": {
        "alt_text": "Modern white kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019fcdf4-b47d-76ec-8932-2c7f1db9bc98",
        "storage_key": "property/6767906449166315/019fcdf4-b47d-76ec-8932-2c7f1db9bc98.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Chic and contemporary kitchen featuring white cabinetry, sleek countertops, a stainless steel dishwasher, oven, and microwave. Perfect for preparing gourmet meals.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, marble countertops, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7b1da63d/dms3rep/multi/5767906449162442/6767906449166315/82425b2f8e33cac4ffadc454290d3c84.jpg"
    },
    {
      "id": "custom_dbd0984e-0cc2-4d08-8f3e-84b9aecd7444",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-b46f-7089-bf43-3c5025cc6250.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, nightstand, dresser, and window.",
        "public_id": "019fcdf4-b46f-7089-bf43-3c5025cc6250",
        "storage_key": "property/6767906449166315/019fcdf4-b46f-7089-bf43-3c5025cc6250.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, featuring a plush queen-size bed, elegant nightstand, and a spacious dresser. Large windows provide natural light.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a made bed, two nightstands, lamps, wall art, and a window AC unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7b1da63d/dms3rep/multi/5767906449162442/6767906449166315/b7ac9127604c61c6805aeb8e5cdeb063.jpg"
    },
    {
      "id": "custom_9b5e8019-0b5e-4d19-ad89-a9a7c26429a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-b4c5-71ae-adbe-9538081aa66f.webp",
      "image_media": {
        "alt_text": "Dining area with a round table set for four, adjacent to a kitchen.",
        "public_id": "019fcdf4-b4c5-71ae-adbe-9538081aa66f",
        "storage_key": "property/6767906449166315/019fcdf4-b4c5-71ae-adbe-9538081aa66f.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Bright, modern apartment with an open dining area, white cabinetry, and a cozy living space.",
      "link": "",
      "alt_text": "Open-concept apartment interior with round dining table, wooden chairs, and a white kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7b1da63d/dms3rep/multi/5767906449162442/6767906449166315/c720f1190cac1a9bb32f98a71c0af8ef.jpg"
    },
    {
      "id": "custom_4f1fe592-1dbc-4536-89ad-d06f366c28e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-b4de-770a-b877-6a4399cfdb00.webp",
      "image_media": {
        "alt_text": "Dining area with table and chairs, leading to a kitchen and a sliding door with a view of the outdoors.",
        "public_id": "019fcdf4-b4de-770a-b877-6a4399cfdb00",
        "storage_key": "property/6767906449166315/019fcdf4-b4de-770a-b877-6a4399cfdb00.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Enjoy meals in this dining area featuring a stylish table and chairs, adjacent to a modern kitchen. Access your private outdoor space through the sliding glass doors.",
      "link": "",
      "alt_text": "Dining area with round wooden table and beige upholstered chairs; open kitchen in the background; sliding balcony door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7b1da63d/dms3rep/multi/5767906449162442/6767906449166315/f2b5304f34fe8e551c1fc4863d6f4268.jpg"
    },
    {
      "id": "custom_a81c9655-a583-422a-8e02-b3c5a68da5a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-beff-75ef-90fe-a14c11571e49.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white subway tile backsplash, and marble countertops.",
        "public_id": "019fcdf4-beff-75ef-90fe-a14c11571e49",
        "storage_key": "property/6767906449166315/019fcdf4-beff-75ef-90fe-a14c11571e49.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "A clean, contemporary kitchen with white cabinets, marble-style countertops, and stainless steel appliances.",
      "link": "",
      "alt_text": "Bright, modern white kitchen with stainless steel appliances and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7b1da63d/dms3rep/multi/5767906449162442/6767906449166315/8330c9576aef3958411e9b96285065d9.jpg"
    },
    {
      "id": "custom_29298b8e-6f8d-4084-941e-7fbbb11cfd7e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-c043-735b-a967-76150a2e7d06.webp",
      "image_media": {
        "alt_text": "Stacked LG washer and dryer next to a linen closet and a bathroom vanity.",
        "public_id": "019fcdf4-c043-735b-a967-76150a2e7d06",
        "storage_key": "property/6767906449166315/019fcdf4-c043-735b-a967-76150a2e7d06.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Apartment",
      "description": "Modern apartment laundry area featuring stacked washer and dryer in a closet, with a vanity and shelving nearby.",
      "link": "",
      "alt_text": "Stacked front-load washer and dryer in a laundry closet with a bathroom vanity nearby.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7b1da63d/dms3rep/multi/5767906449162442/6767906449166315/6ae1e0d567307b0ef0c092ddc3df03c7.webp"
    },
    {
      "id": "custom_5ffffdf4-917d-4048-992d-5b8bdf37575c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-c1be-771f-9547-3338f2ffdf72.webp",
      "image_media": {
        "alt_text": "Living room and dining area with large television, sofa, and dining table.",
        "public_id": "019fcdf4-c1be-771f-9547-3338f2ffdf72",
        "storage_key": "property/6767906449166315/019fcdf4-c1be-771f-9547-3338f2ffdf72.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Spacious living area in a modern apartment with a seating area and open dining space.",
      "link": "",
      "alt_text": "Living room with a black sofa, coffee table, TV, and an adjacent dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7b1da63d/dms3rep/multi/5767906449162442/6767906449166315/9a6433baa4301fe8269b7485c2ef9fe5.jpg"
    },
    {
      "id": "custom_d4f18acb-4a18-44bc-ba6a-df18fa7f308b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-c1f7-70b9-9de4-76170032637c.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, stainless steel appliances including a microwave and oven, and a granite countertop with a sink.",
        "public_id": "019fcdf4-c1f7-70b9-9de4-76170032637c",
        "storage_key": "property/6767906449166315/019fcdf4-c1f7-70b9-9de4-76170032637c.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen featuring dark cabinetry, granite countertops, and stainless steel appliances.",
      "link": "",
      "alt_text": "Kitchen with dark wood cabinets, granite counters, and stainless appliances surrounding a sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7b1da63d/dms3rep/multi/5767906449162442/6767906449166315/2c5512d1dded1777835f57b2b72d3dbf.jpg"
    },
    {
      "id": "custom_761ddf78-d198-481b-ba39-a3986b5f2f79",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-cb4b-758f-a573-b42f8bd61801.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and granite countertops.",
        "public_id": "019fcdf4-cb4b-758f-a573-b42f8bd61801",
        "storage_key": "property/6767906449166315/019fcdf4-cb4b-758f-a573-b42f8bd61801.webp",
        "width": 1920,
        "height": 1440
      },
      "title": "Apartment",
      "description": "Open-concept apartment kitchen featuring dark cabinetry, granite countertops, and stainless appliances including a gas range, dishwasher, and fridge.",
      "link": "",
      "alt_text": "Modern apartment kitchen with dark wood cabinets, stainless steel appliances, and a window above the sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7b1da63d/dms3rep/multi/5767906449162442/6767906449166315/88446b26d5b8ee8fa9cc9048b5745404.jpg"
    },
    {
      "id": "custom_b8f8c65a-d539-4266-acf9-d68f7d678984",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-cdca-73a9-9e61-68567baa22e3.webp",
      "image_media": {
        "alt_text": "Kitchen with white refrigerator, stacked washer and dryer, granite countertops, wood cabinets, and a stovetop.",
        "public_id": "019fcdf4-cdca-73a9-9e61-68567baa22e3",
        "storage_key": "property/6767906449166315/019fcdf4-cdca-73a9-9e61-68567baa22e3.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "A well-equipped kitchen featuring a full-size refrigerator, convenient stacked washer and dryer, ample cabinet space, and modern granite countertops.",
      "link": "",
      "alt_text": "Compact kitchen with stacked washer/dryer, wooden cabinets, sink, and stove.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7b1da63d/dms3rep/multi/5767906449162442/6767906449166315/059ee67db0a644b2a77952b54e463078.jpg"
    },
    {
      "id": "custom_bcdf61f1-9bcc-4208-91af-7dc029ea47c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-cadf-701c-99be-9cdd1bc91bdc.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and shower.",
        "public_id": "019fcdf4-cadf-701c-99be-9cdd1bc91bdc",
        "storage_key": "property/6767906449166315/019fcdf4-cadf-701c-99be-9cdd1bc91bdc.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with marble vanity top, large mirror, and open shelving for linens.",
      "link": "",
      "alt_text": "Bright bathroom with white vanity, marble countertop, large mirror, and shelves holding towels.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7b1da63d/dms3rep/multi/5767906449162442/6767906449166315/e1eeeae089bb481e43a56bec901a5f26.jpg"
    },
    {
      "id": "custom_64d07000-8162-4add-831d-ada2c9ab9460",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-d48c-774d-abe3-17a0d81c9730.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub with shower.",
        "public_id": "019fcdf4-d48c-774d-abe3-17a0d81c9730",
        "storage_key": "property/6767906449166315/019fcdf4-d48c-774d-abe3-17a0d81c9730.webp",
        "width": 640,
        "height": 480
      },
      "title": "Apartment",
      "description": "A bright and clean bathroom featuring a single vanity, toilet, and a bathtub with a shower.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b22d8c7f-872b-4025-9767-7f8a8c9cec66",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-d5d1-719d-a8b8-9d8101ce74c2.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019fcdf4-d5d1-719d-a8b8-9d8101ce74c2",
        "storage_key": "property/6767906449166315/019fcdf4-d5d1-719d-a8b8-9d8101ce74c2.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas for relaxation.",
      "link": "",
      "alt_text": "Swimming pool with blue water and surrounding lounge chairs under a sunny sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7b1da63d/dms3rep/multi/Fox_Pointe_0003__20160803_foxpointe-kettler-0209_xfg70s.jpg"
    },
    {
      "id": "custom_b2cfd5d6-d33c-48e0-b11e-698e5d5a5d65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-d6ef-74f8-b91c-40537489d784.webp",
      "image_media": {
        "alt_text": "Gym with weights, cardio machines, and motivational text on the wall.",
        "public_id": "019fcdf4-d6ef-74f8-b91c-40537489d784",
        "storage_key": "property/6767906449166315/019fcdf4-d6ef-74f8-b91c-40537489d784.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a wide range of weights and cardio equipment, perfect for your workout needs.",
      "link": "",
      "alt_text": "Indoor fitness center with dumbbells, a weight rack, benches and cardio machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7b1da63d/dms3rep/multi/5767906449162442/6767906449166315/360d13f8881aae404cce7478ee356843.jpg"
    },
    {
      "id": "custom_790c3888-823a-410f-897b-0b93876d182b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-de4c-70fb-a0cc-0ed132bd6ff9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a table with wine and cheese.",
        "public_id": "019fcdf4-de4c-70fb-a0cc-0ed132bd6ff9",
        "storage_key": "property/6767906449166315/019fcdf4-de4c-70fb-a0cc-0ed132bd6ff9.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Outdoor pool area at a multifamily community with lounge chairs along the deck.",
      "link": "",
      "alt_text": "Outdoor pool area with lounge chairs and an umbrella at a multifamily community.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7b1da63d/dms3rep/multi/5767906449162442/6767906449166315/2255b43cce6f91fd418e425cd13f454d.jpg"
    },
    {
      "id": "custom_bddaa06c-4ac6-4f4c-96bb-aa2a6b09f32d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e1fc-760e-a2ae-b6723e8fc8dd.webp",
      "image_media": {
        "alt_text": "Modern gym with treadmills, ellipticals, weight machines, and motivational wall art.",
        "public_id": "019fcdf4-e1fc-760e-a2ae-b6723e8fc8dd",
        "storage_key": "property/6767906449166315/019fcdf4-e1fc-760e-a2ae-b6723e8fc8dd.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring state-of-the-art cardio and strength training equipment. Enjoy your workout with a view of the sparkling outdoor pool.",
      "link": "",
      "alt_text": "Bright apartment gym with cardio machines and orange accent wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/7b1da63d/dms3rep/multi/5767906449162442/6767906449166315/666883a9ed7a9dac048ad89d53ba7fcc.jpg"
    },
    {
      "id": "custom_b5469b2f-4bde-4933-8e14-ad5547b85b1f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/01a0f880-5dd9-70be-848a-62e9758cb13c.webp",
      "image_media": {
        "alt_text": "Fox Pointe Apartment Homes monument sign in front of lush greenery.",
        "public_id": "01a0f880-5dd9-70be-848a-62e9758cb13c",
        "storage_key": "property/6767906449166315/01a0f880-5dd9-70be-848a-62e9758cb13c.webp",
        "width": 3072,
        "height": 2045
      },
      "title": "Community",
      "description": "Welcome to Fox Pointe Apartment Homes, featuring a beautiful monument sign surrounded by manicured landscaping and mature trees.",
      "link": "",
      "alt_text": "Fox Pointe Apartment Homes monument sign in front of lush greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8c4aa030-1875-40e5-b4e8-464263d6fd0c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/01a0f880-5f76-77c8-9288-c0cb33bee7c3.webp",
      "image_media": {
        "alt_text": "Exterior of brick apartment buildings with white doors and windows, surrounded by green landscaping and trees.",
        "public_id": "01a0f880-5f76-77c8-9288-c0cb33bee7c3",
        "storage_key": "property/6767906449166315/01a0f880-5f76-77c8-9288-c0cb33bee7c3.webp",
        "width": 3072,
        "height": 2044
      },
      "title": "Community",
      "description": "Charming brick apartment buildings with well-maintained landscaping, featuring private entrances and lush greenery.",
      "link": "",
      "alt_text": "Exterior of brick apartment buildings with white doors and windows, surrounded by green landscaping and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_27da896c-5b24-437a-a08b-a7dfa9c5c28e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Verdant Cafe",
      "poi_type": "Restaurants",
      "poi_address": "600 Warwick Rd, Hi-Nella, NJ 08083, USA",
      "poi_short_description": "Compact plant-decorated kitchen serving soups, wraps, burritos, salads and bowls, as well as chicken sandwiches, fries and rice dishes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-f94a-77f1-b4c8-1a76182f91ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-f94a-77f1-b4c8-1a76182f91ce",
        "storage_key": "property/6767906449166315/019fcdf4-f94a-77f1-b4c8-1a76182f91ce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://verdant-cafe.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6674671603774253914&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "verdant-cafe",
      "poi_latitude": "39.8366141",
      "poi_longitude": "-75.0237391",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 856-625-0032",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfc9-71b9-8762-03ef3278f7b9",
        "storage_key": "property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAz19yyfNxokRWutZr3UyoVw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_296ab60d-85fc-4902-83da-17ed16f8fc94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Nuccio's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "600 S Warwick Rd, Hi-Nella, NJ 08083, USA",
      "poi_short_description": "Casual restaurant dishing up pies, Italian grub, sandwiches, and wings, plus delivery.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-f8b0-7459-bf1f-336bfba4b1b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-f8b0-7459-bf1f-336bfba4b1b0",
        "storage_key": "property/6767906449166315/019fcdf4-f8b0-7459-bf1f-336bfba4b1b0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.nucciospizzaofnj.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14611040317171464351&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nuccios-pizza",
      "poi_latitude": "39.8364767",
      "poi_longitude": "-75.0235163",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 856-258-6326",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfc9-71b9-8762-03ef3278f7b9",
        "storage_key": "property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ6dYjpnNxokRn3jqf8HXxMo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_faa2b1b0-8e40-4cbf-ab39-8cd2cae8e364",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Wilson's Restaurant & Live Music",
      "poi_type": "Restaurants",
      "poi_address": "709 Warwick Rd, Hi-Nella, NJ 08083, USA",
      "poi_short_description": "Relaxed, black-owned venue showcasing live music, comedy shows, dancing and brunch options.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-f8fd-779d-a4e3-cb8a007a3825.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-f8fd-779d-a4e3-cb8a007a3825",
        "storage_key": "property/6767906449166315/019fcdf4-f8fd-779d-a4e3-cb8a007a3825.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://wilsonslivemusic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17546391065718618355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wilsons-restaurant--live-music",
      "poi_latitude": "39.8343464",
      "poi_longitude": "-75.023506",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 856-725-5125",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfc9-71b9-8762-03ef3278f7b9",
        "storage_key": "property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ47XxcN_NxokR8_g-orVNgfM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_813c5145-d6bf-4a59-9128-3b9733674c1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "The Warwick Tavern",
      "poi_type": "Restaurants",
      "poi_address": "400 S Warwick Rd, Somerdale, NJ 08083, USA",
      "poi_short_description": "Chill, game-day hangout featuring wings in lots of flavors, plus other bar eats,19+ TVs & games.",
      "poi_long_description": "Chill, game-day hangout featuring wings in lots of flavors, plus other bar eats,19+ TVs & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-f8a9-717d-805a-f8509f35e623.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-f8a9-717d-805a-f8509f35e623",
        "storage_key": "property/6767906449166315/019fcdf4-f8a9-717d-805a-f8509f35e623.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3459401318947990191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-warwick-tavern",
      "poi_latitude": "39.8377556",
      "poi_longitude": "-75.0249891",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 856-346-9425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfd7-7733-881e-20dba0ed2ed8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfd7-7733-881e-20dba0ed2ed8",
        "storage_key": "property/6767906449166315/019d0265-cfd7-7733-881e-20dba0ed2ed8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGy90zJnNxokRr6ppvytDAjA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fd61ced2-9611-4a47-8b12-92ab269be501",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Amy's Omelette House - Somerdale",
      "poi_type": "Restaurants",
      "poi_address": "9 S White Horse Pike, Somerdale, NJ 08083, USA",
      "poi_short_description": "Cozy eatery specializing in omelettes and pancakes, plus classic breakfast fare and French toast.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-ff71-737a-9d1b-47567aaf614e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-ff71-737a-9d1b-47567aaf614e",
        "storage_key": "property/6767906449166315/019fcdf4-ff71-737a-9d1b-47567aaf614e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://amystogo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5857227442022785140&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amys-omelette-house---somerdale",
      "poi_latitude": "39.8434604",
      "poi_longitude": "-75.0178056",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 856-805-7607",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfc9-71b9-8762-03ef3278f7b9",
        "storage_key": "property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwyYQ8dbNxokRdCBwWlMNSVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b38ae593-c7a4-49d3-a1f8-b4174e5d88b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Lorenzo's Trattoria Italiana & Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "701 N White Horse Pike, Somerdale, NJ 08083, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-fed6-77ea-b424-e93ccd7f7d1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-fed6-77ea-b424-e93ccd7f7d1f",
        "storage_key": "property/6767906449166315/019fcdf4-fed6-77ea-b424-e93ccd7f7d1f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2935466479373918979&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lorenzos-trattoria-italiana--pizzeria",
      "poi_latitude": "39.851829",
      "poi_longitude": "-75.0250162",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 856-784-0007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfc9-71b9-8762-03ef3278f7b9",
        "storage_key": "property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvZVz6q_NxokRAyMm0TXfvCg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d54d74cb-479a-4a30-919e-ee91d638373d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Casa D'Amico Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "69 Warwick Rd, Stratford, NJ 08084, USA",
      "poi_short_description": "Pizzeria with delivery and an adjacent dining room featuring Italian eats like pizza and pasta, plus seafood dishes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-ffb3-76db-baad-f2f7e0302762.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-ffb3-76db-baad-f2f7e0302762",
        "storage_key": "property/6767906449166315/019fcdf4-ffb3-76db-baad-f2f7e0302762.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://casadamicos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4048834813839825729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "casa-damico-italian-restaurant",
      "poi_latitude": "39.8305107",
      "poi_longitude": "-75.0182992",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 856-782-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfc9-71b9-8762-03ef3278f7b9",
        "storage_key": "property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxdwHxJzNxokRQVsowc9ZMDg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2bdff1cc-169b-4113-8957-63ace67708a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "China Cook Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "711 Evesham Rd #15, Somerdale, NJ 08083, USA",
      "poi_short_description": "Casual eatery dishing up classic Chinese fare (including lunch specials), plus sushi, pad Thai and poke bowls.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-ffed-753b-baeb-66db9f618720.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf4-ffed-753b-baeb-66db9f618720",
        "storage_key": "property/6767906449166315/019fcdf4-ffed-753b-baeb-66db9f618720.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chinacookexpress.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15728659142330875153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "china-cook-restaurant",
      "poi_latitude": "39.8549797",
      "poi_longitude": "-75.0209728",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 856-258-5667",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfc9-71b9-8762-03ef3278f7b9",
        "storage_key": "property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSwCPqK7NxokREf3U6ydsR9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7403f73d-8f07-4d75-9b42-7d7245c195a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Armageddon Brewing",
      "poi_type": "Restaurants",
      "poi_address": "900 Chestnut Ave building j, Somerdale, NJ 08083, USA",
      "poi_short_description": "Spacious, relaxed, welcoming destination specializing in ciders and meads, plus a laid-back vibe and friendly staff.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-0459-717f-89c8-48ada79501ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-0459-717f-89c8-48ada79501ea",
        "storage_key": "property/6767906449166315/019fcdf5-0459-717f-89c8-48ada79501ea.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.armageddon-brewing.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14423006988471622028&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "armageddon-brewing",
      "poi_latitude": "39.8527101",
      "poi_longitude": "-75.0225565",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 856-599-5214",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfd7-7733-881e-20dba0ed2ed8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfd7-7733-881e-20dba0ed2ed8",
        "storage_key": "property/6767906449166315/019d0265-cfd7-7733-881e-20dba0ed2ed8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtWNe5rvNxokRjNnTjHDQKMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_91e95126-c1d6-439d-b7b3-3864c575bc56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Sweet Eats Bakery",
      "poi_type": "Restaurants",
      "poi_address": "310 S Burnt Mill Rd, Voorhees Township, NJ 08043, USA",
      "poi_short_description": "Old-fashioned, family-operated bakery producing pies, pastries, cookies & custom-decorated cakes.",
      "poi_long_description": "Old-fashioned, family-operated bakery producing pies, pastries, cookies & custom-decorated cakes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-0667-7778-b83e-f5edbb6d7b3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-0667-7778-b83e-f5edbb6d7b3d",
        "storage_key": "property/6767906449166315/019fcdf5-0667-7778-b83e-f5edbb6d7b3d.webp",
        "width": 1280,
        "height": 711
      },
      "poi_business_url": "http://www.sweeteatsbakery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4324990546845082752&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sweet-eats-bakery",
      "poi_latitude": "39.853897",
      "poi_longitude": "-75.008055",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 856-429-2005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfc9-71b9-8762-03ef3278f7b9",
        "storage_key": "property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ456hIKHNxokRgKSf0fxzBTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b7dfc517-06a4-4bce-b66c-2d7314abe027",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Rodizio Grill - Voorhees",
      "poi_type": "Restaurants",
      "poi_address": "13109 Town Center Blvd, Voorhees Township, NJ 08043, USA",
      "poi_short_description": "Outpost of a Brazilian steakhouse chain offering skewered meats carved tableside, plus a salad bar.",
      "poi_long_description": "Outpost of a Brazilian steakhouse chain offering skewered meats carved tableside, plus a salad bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-0637-7339-a01f-e77fabe08037.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-0637-7339-a01f-e77fabe08037",
        "storage_key": "property/6767906449166315/019fcdf5-0637-7339-a01f-e77fabe08037.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.rodiziogrill.com/voorhees/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3418653492286328943&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rodizio-grill---voorhees",
      "poi_latitude": "39.8515417",
      "poi_longitude": "-74.9987616",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 856-344-5110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfc9-71b9-8762-03ef3278f7b9",
        "storage_key": "property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSdJkmxvNxokRbxDgCT1_cS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f53e2135-128a-47b2-96bc-4442bf97cd8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Elena Wu Restaurant & Sushi Bar",
      "poi_type": "Restaurants",
      "poi_address": "12106 Town Center Blvd, Voorhees Township, NJ 08043, USA",
      "poi_short_description": "Classic Chinese dishes, sushi & lunch specials are the draws at this modern shopping-center option.",
      "poi_long_description": "Classic Chinese dishes, sushi & lunch specials are the draws at this modern shopping-center option.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-0643-70f2-a68e-86e42f09c178.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-0643-70f2-a68e-86e42f09c178",
        "storage_key": "property/6767906449166315/019fcdf5-0643-70f2-a68e-86e42f09c178.webp",
        "width": 1024,
        "height": 681
      },
      "poi_business_url": "https://order.online/business/elena-wu-restaurant--sushi-bar-117104",
      "poi_directions_map_url": "https://maps.google.com/?cid=14215697673854869160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elena-wu-restaurant--sushi-bar",
      "poi_latitude": "39.851373",
      "poi_longitude": "-74.99937440000001",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 856-375-2289",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfc9-71b9-8762-03ef3278f7b9",
        "storage_key": "property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7bUtmxvNxokRqF53ZLdNSMU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_63eafcf8-ba42-474e-af29-b4a061f1b0e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Rick's Farm",
      "poi_type": "Shopping",
      "poi_address": "428 N Warwick Rd, Somerdale, NJ 08083, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-09e2-76ab-a3e1-9e729eafcd4e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-09e2-76ab-a3e1-9e729eafcd4e",
        "storage_key": "property/6767906449166315/019fcdf5-09e2-76ab-a3e1-9e729eafcd4e.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11000050365248670031&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ricks-farm",
      "poi_latitude": "39.8492842",
      "poi_longitude": "-75.0314278",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 856-435-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfda-71f8-984e-88da3e5150e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfda-71f8-984e-88da3e5150e4",
        "storage_key": "property/6767906449166315/019d0265-cfda-71f8-984e-88da3e5150e4.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJpb16LrrNxokRT4kNxIYHqJg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3a5659ad-83fe-433e-85b1-66da23bd0d2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Dollar Plus Food Mart",
      "poi_type": "Shopping",
      "poi_address": "507 N Warwick Rd, Somerdale, NJ 08083, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-0c17-7134-a266-2d56ff5181d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-0c17-7134-a266-2d56ff5181d3",
        "storage_key": "property/6767906449166315/019fcdf5-0c17-7134-a266-2d56ff5181d3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10356454214619848839&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-plus-food-mart",
      "poi_latitude": "39.8502813",
      "poi_longitude": "-75.0326615",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 856-373-6920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfda-71f8-984e-88da3e5150e4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfda-71f8-984e-88da3e5150e4",
        "storage_key": "property/6767906449166315/019d0265-cfda-71f8-984e-88da3e5150e4.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJhWE9k7nNxokRh2ADwzyEuY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_43c0eafa-c758-4e32-92e9-ea6206f7e3dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Rite Aid",
      "poi_type": "Shopping",
      "poi_address": "608 N Warwick Rd, Somerdale, NJ 08083, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-0b73-73bf-a008-d54e2a0b7a03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-0b73-73bf-a008-d54e2a0b7a03",
        "storage_key": "property/6767906449166315/019fcdf5-0b73-73bf-a008-d54e2a0b7a03.webp",
        "width": 251,
        "height": 250
      },
      "poi_business_url": "https://www.riteaid.com/locations/nj/somerdale/608-north-warwick-road.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7447761265504676198&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rite-aid",
      "poi_latitude": "39.849702",
      "poi_longitude": "-75.032735",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 856-784-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfe4-72e5-8c26-403777192353",
        "storage_key": "property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-fwiX0jNxokRZulROmnDW2c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4b9cd106-d64d-44d5-a19a-42b65bfeb2f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Wawa",
      "poi_type": "Shopping",
      "poi_address": "2 N White Horse Pike, Somerdale, NJ 08083, USA",
      "poi_short_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_long_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-0c1d-753d-8a67-17cfec29180e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-0c1d-753d-8a67-17cfec29180e",
        "storage_key": "property/6767906449166315/019fcdf5-0c1d-753d-8a67-17cfec29180e.webp",
        "width": 500,
        "height": 400
      },
      "poi_business_url": "https://www.wawa.com/locations/8346?utm_source=gmblisting&utm_medium=organic&utm_campaign=locallisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=3000031913286702542&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wawa",
      "poi_latitude": "39.84473",
      "poi_longitude": "-75.01818",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 609-672-4577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfc9-71b9-8762-03ef3278f7b9",
        "storage_key": "property/6767906449166315/019d0265-cfc9-71b9-8762-03ef3278f7b9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs4oNNKHNxokRzhVKWiFBoik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_652868cf-e60d-442d-a22e-2e3f7b89141b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "ShopRite of Lawnside",
      "poi_type": "Shopping",
      "poi_address": "130 N White Horse Pike, Lawnside, NJ 08045, USA",
      "poi_short_description": "Supermarket chain with brand-name & house-label groceries, plus a bakery & a deli.",
      "poi_long_description": "Supermarket chain with brand-name & house-label groceries, plus a bakery & a deli.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-1027-73cb-91af-dad8c16878fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-1027-73cb-91af-dad8c16878fd",
        "storage_key": "property/6767906449166315/019fcdf5-1027-73cb-91af-dad8c16878fd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.shoprite.com/?utm_source=GMB&utm_medium=Local_Search&utm_campaign=dbaPlatform&utm_term=534",
      "poi_directions_map_url": "https://maps.google.com/?cid=13259284878348749023&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shoprite-of-lawnside",
      "poi_latitude": "39.8674729",
      "poi_longitude": "-75.0420994",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 856-547-2590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d580-72aa-9a06-16efba1a7025.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d580-72aa-9a06-16efba1a7025",
        "storage_key": "property/6767906449166315/019d0265-d580-72aa-9a06-16efba1a7025.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPSpJJDTMxokR34ivnVhxArg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0637dcd0-16ce-426e-abc6-7abbb91907a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "John's Friendly Market",
      "poi_type": "Shopping",
      "poi_address": "622 Station Ave, Haddon Heights, NJ 08035, USA",
      "poi_short_description": "Supermarket, deli and butcher selling a variety of products, including meats and cheese, plus sandwiches and roast meat.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-112d-72e9-ba6f-0cc84fac3e68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-112d-72e9-ba6f-0cc84fac3e68",
        "storage_key": "property/6767906449166315/019fcdf5-112d-72e9-ba6f-0cc84fac3e68.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.facebook.com/profile.php?id=100031093215852",
      "poi_directions_map_url": "https://maps.google.com/?cid=11745319959605371279&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johns-friendly-market",
      "poi_latitude": "39.8814235",
      "poi_longitude": "-75.0595247",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 856-547-6132",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d580-72aa-9a06-16efba1a7025.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d580-72aa-9a06-16efba1a7025",
        "storage_key": "property/6767906449166315/019d0265-d580-72aa-9a06-16efba1a7025.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVJBwCDMxokRj2GVHUbC_6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b15b05b3-4620-49ef-841e-576399fbb1bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "ACME Markets",
      "poi_type": "Shopping",
      "poi_address": "501 E Evesham Rd, Runnemede, NJ 08078, USA",
      "poi_short_description": "Grocery chain featuring a bakery and deli, plus fresh and frozen food.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-113d-7526-8cb9-8346ed84ae77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-113d-7526-8cb9-8346ed84ae77",
        "storage_key": "property/6767906449166315/019fcdf5-113d-7526-8cb9-8346ed84ae77.webp",
        "width": 622,
        "height": 349
      },
      "poi_business_url": "https://local.acmemarkets.com/nj/runnemede/501-e-evesham-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=9640909777255072230&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "acme-markets",
      "poi_latitude": "39.8491881",
      "poi_longitude": "-75.05932779999999",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 856-939-5403",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d580-72aa-9a06-16efba1a7025.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d580-72aa-9a06-16efba1a7025",
        "storage_key": "property/6767906449166315/019d0265-d580-72aa-9a06-16efba1a7025.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3ZKWPd_NxokR5gHh2Fxky4U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_07ea86b1-e501-4b53-82ad-556d54440e29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping",
      "poi_address": "1 Coopertowne Blvd, Somerdale, NJ 08083, USA",
      "poi_short_description": "Chains (including a super version) selling everything from groceries to toys.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-1298-762b-ad4d-49d298de7140.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-1298-762b-ad4d-49d298de7140",
        "storage_key": "property/6767906449166315/019fcdf5-1298-762b-ad4d-49d298de7140.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/4456-somerdale-nj/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=7919809863768078460&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "39.8547222",
      "poi_longitude": "-75.02361110000001",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 856-545-9052",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d646-7401-a32d-5cf202d8d454.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d646-7401-a32d-5cf202d8d454",
        "storage_key": "property/6767906449166315/019d0265-d646-7401-a32d-5cf202d8d454.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJha1-Za7NxokRfPiHMhzR6G0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1e03c498-24ab-4233-b93f-6524c586f77f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping",
      "poi_address": "711 Evesham Ave E # 4, Somerdale, NJ 08083, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-1692-74f8-bfa5-acee8c31fd07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-1692-74f8-bfa5-acee8c31fd07",
        "storage_key": "property/6767906449166315/019fcdf5-1692-74f8-bfa5-acee8c31fd07.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://locations.dollartree.com/nj/somerdale/711-evesham-ave-unit-4?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=14356836284875310617&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "39.8557172",
      "poi_longitude": "-75.01940859999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 856-258-7598",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d646-7401-a32d-5cf202d8d454.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d646-7401-a32d-5cf202d8d454",
        "storage_key": "property/6767906449166315/019d0265-d646-7401-a32d-5cf202d8d454.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJY6I_7qvNxokRGYZuCom6Pcc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9275dd88-d549-4e59-b965-95da4eb4a942",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Devone's Liquors",
      "poi_type": "Shopping",
      "poi_address": "600 S Warwick Rd # 7, Hi-Nella, NJ 08083, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11338155103263197798&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "devones-liquors",
      "poi_latitude": "39.8366821",
      "poi_longitude": "-75.02380749999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 856-784-4333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d646-7401-a32d-5cf202d8d454.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d646-7401-a32d-5cf202d8d454",
        "storage_key": "property/6767906449166315/019d0265-d646-7401-a32d-5cf202d8d454.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQ6dYjpnNxokRZgpJiv43WZ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_275b39f5-b809-40a3-b3b2-9366a2ece6c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Parkview Elementary School",
      "poi_type": "Education",
      "poi_address": "123 Parkview Rd, Stratford, NJ 08084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://parkview.stratford.k12.nj.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14115844439979300760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parkview-elementary-school",
      "poi_latitude": "39.83010669999999",
      "poi_longitude": "-75.0315203",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 856-783-2876",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d587-7418-be3a-d2c473e1c18e",
        "storage_key": "property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEXaNdY7NxokRmJejrbqN5cM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_628e29fe-8d96-4399-b028-fa65ac7e55f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Samuel S Yellin School",
      "poi_type": "Education",
      "poi_address": "111 Warwick Rd, Stratford, NJ 08084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://yellin.stratford.k12.nj.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4593415261863239304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "samuel-s-yellin-school",
      "poi_latitude": "39.8319468",
      "poi_longitude": "-75.01919110000001",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 856-783-1094",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d587-7418-be3a-d2c473e1c18e",
        "storage_key": "property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNQ7qiZzNxokRiF43_dcWvz8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5731a61f-28e6-4698-b79c-aba21beaf0fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Sterling High School",
      "poi_type": "Education",
      "poi_address": "501 S Warwick Rd, Somerdale, NJ 08083, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.sterling.k12.nj.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3944573468950186470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sterling-high-school",
      "poi_latitude": "39.8360706",
      "poi_longitude": "-75.0258842",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 856-784-1333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d587-7418-be3a-d2c473e1c18e",
        "storage_key": "property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsT_Bg5DNxokR5sk0t6vwvTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_103da468-3953-4b12-a450-6661df180679",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Somerdale Park School",
      "poi_type": "Education",
      "poi_address": "301 Grace St, Somerdale, NJ 08083, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://somerdale-park.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7197602956515036298&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "somerdale-park-school",
      "poi_latitude": "39.8498172",
      "poi_longitude": "-75.02095659999999",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 856-783-6261",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d587-7418-be3a-d2c473e1c18e",
        "storage_key": "property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdV039qXNxokRikxhIcEF42M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3505362d-77bf-4b6e-8076-3dbe7afedc0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Saint John Paul II Regional School",
      "poi_type": "Education",
      "poi_address": "55 Warwick Rd, Stratford, NJ 08084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.jp2rs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11944434766476960497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-john-paul-ii-regional-school",
      "poi_latitude": "39.82970299999999",
      "poi_longitude": "-75.0169384",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 856-783-3088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d587-7418-be3a-d2c473e1c18e",
        "storage_key": "property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJiX_11YLNxokR8WKvwiIow6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3474ba13-0e02-4055-84aa-1663f7c57ee5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Above & Beyond Learning Center",
      "poi_type": "Education",
      "poi_address": "35 Arlington Ave, Stratford, NJ 08084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://aboveandbeyondlearningcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1532438245791500724&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "above--beyond-learning-center",
      "poi_latitude": "39.8301693",
      "poi_longitude": "-74.9994334",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 856-282-6207",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d587-7418-be3a-d2c473e1c18e",
        "storage_key": "property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ90_l-W7NxokRtAmgIHdQRBU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4fa8fe72-0e7b-4bab-ae3b-283c196defd2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Inspire Stratford",
      "poi_type": "Education",
      "poi_address": "44 Berlin Rd, Stratford, NJ 08084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-174f-7461-a9f0-487544ee2911.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-174f-7461-a9f0-487544ee2911",
        "storage_key": "property/6767906449166315/019fcdf5-174f-7461-a9f0-487544ee2911.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://inspireschools.com/location/under-the-sun-stratford-new-jersey-child-care-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1677212052619938082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "inspire-stratford",
      "poi_latitude": "39.8320248",
      "poi_longitude": "-75.00197279999999",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 856-783-9715",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d587-7418-be3a-d2c473e1c18e",
        "storage_key": "property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5bFUD27NxokRIklqwXmnRhc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8c2e9cf4-7386-4ce8-b539-286b53d5ed2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "New Generation Kids Academy learning center",
      "poi_type": "Education",
      "poi_address": "102 Berlin Rd, Stratford, NJ 08084, USA",
      "poi_short_description": "Informal, well-maintained daycare center with a nurturing staff teaching kids through preschool and school ages.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-17f3-75be-bdcb-0a754976714c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-17f3-75be-bdcb-0a754976714c",
        "storage_key": "property/6767906449166315/019fcdf5-17f3-75be-bdcb-0a754976714c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15165129010603003225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-generation-kids-academy-learning-center",
      "poi_latitude": "39.8304373",
      "poi_longitude": "-74.9982557",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 856-344-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d587-7418-be3a-d2c473e1c18e",
        "storage_key": "property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhanxwW7NxokRWY32oXxcddI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ce81aa4c-c1ab-47a7-a768-fa8f0855f288",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Kaleidoscope Kidz Daycare Center",
      "poi_type": "Education",
      "poi_address": "814 N White Horse Pike, Stratford, NJ 08084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=491248948953612845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kaleidoscope-kidz-daycare-center",
      "poi_latitude": "39.839509",
      "poi_longitude": "-75.0128761",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 856-454-5951",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d587-7418-be3a-d2c473e1c18e",
        "storage_key": "property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJyWu6SWLNxokRLQKq-lBE0QY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9de90851-b378-4dbe-9649-b8db83aa6b89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Camden County College",
      "poi_type": "Education",
      "poi_address": "200 College Dr, Blackwood, NJ 08012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-1924-708d-8af0-2023a99856e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-1924-708d-8af0-2023a99856e2",
        "storage_key": "property/6767906449166315/019fcdf5-1924-708d-8af0-2023a99856e2.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.camdencc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17527533757141958008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camden-county-college",
      "poi_latitude": "39.78447600000001",
      "poi_longitude": "-75.03720349999999",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 856-227-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d587-7418-be3a-d2c473e1c18e",
        "storage_key": "property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUVFtsDXSxokReD0dVxZPPvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a6899056-f3e9-4c17-993a-b3d96e672069",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Clementon Park & Splash World",
      "poi_type": "Entertainment",
      "poi_address": "144 Berlin Rd #4504, Clementon, NJ 08021, USA",
      "poi_short_description": "Vivid amusement & water park with an assortment of slides, rides, events & other activities.",
      "poi_long_description": "Vivid amusement & water park with an assortment of slides, rides, events & other activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-1c65-7199-9f55-30724e1d18a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-1c65-7199-9f55-30724e1d18a1",
        "storage_key": "property/6767906449166315/019fcdf5-1c65-7199-9f55-30724e1d18a1.webp",
        "width": 1280,
        "height": 665
      },
      "poi_business_url": "http://www.clementonpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13509288682288233700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clementon-park--splash-world",
      "poi_latitude": "39.803597",
      "poi_longitude": "-74.98531",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 856-783-0263",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfe4-72e5-8c26-403777192353",
        "storage_key": "property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxS0y5rvSxokR5Lz-M3uiers",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7e6c616a-9433-4dae-97ae-3e0a10a2cf1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Cinemark Somerdale 16 and XD",
      "poi_type": "Entertainment",
      "poi_address": "Cooper Town Center, 711 Evesham Rd, Somerdale, NJ 08083, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-1db0-773f-a7dd-d60819ae284b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-1db0-773f-a7dd-d60819ae284b",
        "storage_key": "property/6767906449166315/019fcdf5-1db0-773f-a7dd-d60819ae284b.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.cinemark.com/theatres/nj-somerdale/cinemark-somerdale-16-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMwOTQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11679483647711030393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-somerdale-16-and-xd",
      "poi_latitude": "39.8556738",
      "poi_longitude": "-75.0200962",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 856-784-3429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d640-7512-8e78-ce6e7187d2cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d640-7512-8e78-ce6e7187d2cf",
        "storage_key": "property/6767906449166315/019d0265-d640-7512-8e78-ce6e7187d2cf.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJebJ-B6zNxokReazMPX_cFaI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c69c96e9-5e82-475b-8893-9bf301f3e6f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "AMC Voorhees 16",
      "poi_type": "Entertainment",
      "poi_address": "900 Haddonfield-Berlin Rd, Voorhees Township, NJ 08043, USA",
      "poi_short_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_long_description": "Cineplex with 3D & jumbo digital screens showing first-run films, opera productions & sports events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-1f4a-7328-a959-f5696031f00c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-1f4a-7328-a959-f5696031f00c",
        "storage_key": "property/6767906449166315/019fcdf5-1f4a-7328-a959-f5696031f00c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/philadelphia/amc-voorhees-16?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11184589499941155378&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-voorhees-16",
      "poi_latitude": "39.8467013",
      "poi_longitude": "-74.9794364",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 856-669-3291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d640-7512-8e78-ce6e7187d2cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d640-7512-8e78-ce6e7187d2cf",
        "storage_key": "property/6767906449166315/019d0265-d640-7512-8e78-ce6e7187d2cf.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_arjfSXNxokRMnKORuSkN5s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fb4bef0b-1ee3-4573-8166-1bbbc073f0cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Adventure Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "1 Riverside Dr, Camden, NJ 08103, USA",
      "poi_short_description": "Massive aquarium with a 3D theater, plus hippos, stingrays & an underwater shark tunnel.",
      "poi_long_description": "Massive aquarium with a 3D theater, plus hippos, stingrays & an underwater shark tunnel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-1fa1-7578-982e-c8c8cc55d56f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-1fa1-7578-982e-c8c8cc55d56f",
        "storage_key": "property/6767906449166315/019fcdf5-1fa1-7578-982e-c8c8cc55d56f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.adventureaquarium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2298813021411118508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "adventure-aquarium",
      "poi_latitude": "39.9460868",
      "poi_longitude": "-75.1311712",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 52 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 844-474-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfe4-72e5-8c26-403777192353",
        "storage_key": "property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBU1gv_LIxokRrI1AakMG5x8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3d24b5e5-6e84-40d3-a14a-bbf97e47c598",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "BB-62 Battleship New Jersey",
      "poi_type": "Entertainment",
      "poi_address": "100 Clinton St, Camden, NJ 08103, USA",
      "poi_short_description": "Visitors can tour the decommissioned battleship's 887-ft.-long deck & sailors’ living quarters.",
      "poi_long_description": "Visitors can tour the decommissioned battleship's 887-ft.-long deck & sailors’ living quarters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-229d-7647-8590-d146e51b69cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-229d-7647-8590-d146e51b69cc",
        "storage_key": "property/6767906449166315/019fcdf5-229d-7647-8590-d146e51b69cc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.battleshipnewjersey.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11001799642450627255&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bb-62-battleship-new-jersey",
      "poi_latitude": "39.9394484",
      "poi_longitude": "-75.1330734",
      "poi_miles_from_property": "10.5 mi",
      "poi_walking_minutes": "3 hours 54 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 856-966-1652",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-dae7-702a-af32-e30c3db62630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dae7-702a-af32-e30c3db62630",
        "storage_key": "property/6767906449166315/019d0265-dae7-702a-af32-e30c3db62630.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJaxvwROrIxokRtwpKGnw-rpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fceb1bac-ed3e-4471-b1cd-da00c0b120dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Freedom Mortgage Pavilion",
      "poi_type": "Entertainment",
      "poi_address": "1 Harbour Blvd, Camden, NJ 08103, USA",
      "poi_short_description": "Large outdoor performing arts amphitheater transforms into a smaller, enclosed venue for the winter.",
      "poi_long_description": "Large outdoor performing arts amphitheater transforms into a smaller, enclosed venue for the winter.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-2528-7302-9bec-c3244977b696.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-2528-7302-9bec-c3244977b696",
        "storage_key": "property/6767906449166315/019fcdf5-2528-7302-9bec-c3244977b696.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.freedommortgagepavilion.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=5807470010840392946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freedom-mortgage-pavilion",
      "poi_latitude": "39.9404754",
      "poi_longitude": "-75.13001249999999",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 856-365-1300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfe4-72e5-8c26-403777192353",
        "storage_key": "property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS6o4sfPIxokR8iTgnzRHmFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_50a55084-35f8-4fb8-b325-7c79a36b0be7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Camden Children's Garden",
      "poi_type": "Entertainment",
      "poi_address": "3 Riverside Dr, Camden, NJ 08103, USA",
      "poi_short_description": "Family-focused park with a butterfly house, treehouse & themed gardens, plus carousel & train rides.",
      "poi_long_description": "Family-focused park with a butterfly house, treehouse & themed gardens, plus carousel & train rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-25ed-7247-b934-d8cbf9fd7973.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-25ed-7247-b934-d8cbf9fd7973",
        "storage_key": "property/6767906449166315/019fcdf5-25ed-7247-b934-d8cbf9fd7973.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2467232925781527763&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camden-childrens-garden",
      "poi_latitude": "39.9441667",
      "poi_longitude": "-75.1305556",
      "poi_miles_from_property": "10.2 mi",
      "poi_walking_minutes": "3 hours 48 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 856-365-8733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-db78-72de-8bc5-11c4713f739b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-db78-72de-8bc5-11c4713f739b",
        "storage_key": "property/6767906449166315/019d0265-db78-72de-8bc5-11c4713f739b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJebu8Oe3IxokR0wxbJ0ZfPSI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_09b51064-a719-4c32-80e6-66875a685a21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Philadelphia Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "2600 Benjamin Franklin Pkwy, Philadelphia, PA 19130, USA",
      "poi_short_description": "Majestic space with famed entry staircase featuring Renaissance classics & special exhibits.",
      "poi_long_description": "Majestic space with famed entry staircase featuring Renaissance classics & special exhibits.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-26ac-711f-b580-89fdb3f5a12b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-26ac-711f-b580-89fdb3f5a12b",
        "storage_key": "property/6767906449166315/019fcdf5-26ac-711f-b580-89fdb3f5a12b.webp",
        "width": 1057,
        "height": 1280
      },
      "poi_business_url": "https://www.philamuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10027394454499475667&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "philadelphia-museum-of-art",
      "poi_latitude": "39.9655697",
      "poi_longitude": "-75.18096609999999",
      "poi_miles_from_property": "13.8 mi",
      "poi_walking_minutes": "5 hours 13 mins",
      "poi_biking_minutes": "1 hour 26 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 215-763-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-dae7-702a-af32-e30c3db62630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dae7-702a-af32-e30c3db62630",
        "storage_key": "property/6767906449166315/019d0265-dae7-702a-af32-e30c3db62630.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_5CoRebFxokR08ApAyF2KIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cdc49551-61f0-4318-b39c-f2a54fd6d8cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "The Franklin Institute",
      "poi_type": "Entertainment",
      "poi_address": "222 N 20th St, Philadelphia, PA 19103, USA",
      "poi_short_description": "Lively, family-friendly science museum with many interactive exhibits & displays plus a planetarium.",
      "poi_long_description": "Lively, family-friendly science museum with many interactive exhibits & displays plus a planetarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-291f-72de-9377-9045a9127f65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-291f-72de-9377-9045a9127f65",
        "storage_key": "property/6767906449166315/019fcdf5-291f-72de-9377-9045a9127f65.webp",
        "width": 1280,
        "height": 818
      },
      "poi_business_url": "https://www.fi.edu/?utm_source=google&utm_medium=googlemybusiness&utm_campaign=2021",
      "poi_directions_map_url": "https://maps.google.com/?cid=2418395641521861752&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-franklin-institute",
      "poi_latitude": "39.9582109",
      "poi_longitude": "-75.17313469999999",
      "poi_miles_from_property": "13.2 mi",
      "poi_walking_minutes": "4 hours 58 mins",
      "poi_biking_minutes": "1 hour 22 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 215-448-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-dae7-702a-af32-e30c3db62630.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-dae7-702a-af32-e30c3db62630",
        "storage_key": "property/6767906449166315/019d0265-dae7-702a-af32-e30c3db62630.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ05tdhjTGxokReHRD0wXejyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d4d61585-2aff-408b-a072-05ff21796e32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Kimmel Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "300 S Broad St, Philadelphia, PA 19102, USA",
      "poi_short_description": "This glass & steel space is home to the city's orchestra, plus ballet, opera, drama & student works.",
      "poi_long_description": "This glass & steel space is home to the city's orchestra, plus ballet, opera, drama & student works.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-2c57-763b-80b4-7b235109d5ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-2c57-763b-80b4-7b235109d5ab",
        "storage_key": "property/6767906449166315/019fcdf5-2c57-763b-80b4-7b235109d5ab.webp",
        "width": 1184,
        "height": 1280
      },
      "poi_business_url": "http://www.ensembleartsphilly.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5633108419232214587&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kimmel-center-for-the-performing-arts",
      "poi_latitude": "39.9467935",
      "poi_longitude": "-75.165297",
      "poi_miles_from_property": "12.2 mi",
      "poi_walking_minutes": "4 hours 28 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 215-790-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfe4-72e5-8c26-403777192353",
        "storage_key": "property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfWCzLwnGxokROy6ZBUPSLE4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_104b2020-5b16-4c45-bde0-841ce49cb0c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Jefferson Stratford Hospital",
      "poi_type": "Health",
      "poi_address": "18 Laurel Rd East, Stratford, NJ 08084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-2c35-7345-a36d-a5a08b0c1dac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-2c35-7345-a36d-a5a08b0c1dac",
        "storage_key": "property/6767906449166315/019fcdf5-2c35-7345-a36d-a5a08b0c1dac.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.jeffersonhealth.org/locations/stratford-hospital?utm_source=google&utm_medium=organic&utm_campaign=gbp-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17042968694022426207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-stratford-hospital",
      "poi_latitude": "39.8281678",
      "poi_longitude": "-75.00826599999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 856-346-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-db82-776b-97cb-d7e0dfecf4ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-db82-776b-97cb-d7e0dfecf4ef",
        "storage_key": "property/6767906449166315/019d0265-db82-776b-97cb-d7e0dfecf4ef.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZfXwCXrNxokRX05PzbrJhOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_52934031-afb9-4360-a3ad-34598eee0338",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Jefferson Stratford Hospital",
      "poi_type": "Health",
      "poi_address": "18 Laurel Rd East, Stratford, NJ 08084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-2c35-7345-a36d-a5a08b0c1dac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-2c35-7345-a36d-a5a08b0c1dac",
        "storage_key": "property/6767906449166315/019fcdf5-2c35-7345-a36d-a5a08b0c1dac.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.jeffersonhealth.org/locations/stratford-hospital?utm_source=google&utm_medium=organic&utm_campaign=gbp-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17042968694022426207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-stratford-hospital",
      "poi_latitude": "39.8281678",
      "poi_longitude": "-75.00826599999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 856-346-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-db82-776b-97cb-d7e0dfecf4ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-db82-776b-97cb-d7e0dfecf4ef",
        "storage_key": "property/6767906449166315/019d0265-db82-776b-97cb-d7e0dfecf4ef.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZfXwCXrNxokRX05PzbrJhOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_23d5d554-125a-4bee-8982-53acfbbe006e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Virtua Voorhees Hospital",
      "poi_type": "Health",
      "poi_address": "100 Bowman Dr, Voorhees Township, NJ 08043, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-2dc3-766f-93ea-9ebd7bfad2d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-2dc3-766f-93ea-9ebd7bfad2d6",
        "storage_key": "property/6767906449166315/019fcdf5-2dc3-766f-93ea-9ebd7bfad2d6.webp",
        "width": 1280,
        "height": 1260
      },
      "poi_business_url": "https://www.virtua.org/locations/voorhees-hospital?utm_source=local&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13922560869268213923&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virtua-voorhees-hospital",
      "poi_latitude": "39.84165369999999",
      "poi_longitude": "-74.9270074",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 856-247-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-db82-776b-97cb-d7e0dfecf4ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-db82-776b-97cb-d7e0dfecf4ef",
        "storage_key": "property/6767906449166315/019d0265-db82-776b-97cb-d7e0dfecf4ef.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVW1Q0S8zwYkRo1B8gFjfNsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5cbf2a6f-c5fc-46a6-a8cd-1b840241db3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health",
      "poi_address": "69 S White Horse Pike, Stratford, NJ 08084, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-2fff-741e-94e5-dc9128efc50c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-2fff-741e-94e5-dc9128efc50c",
        "storage_key": "property/6767906449166315/019fcdf5-2fff-741e-94e5-dc9128efc50c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/stratford-nj-pharmacies/69-n-white-horse-pike-stratford-nj-08084/storeid=462?WT.mc_id=LS_GOOGLE_FS_462",
      "poi_directions_map_url": "https://maps.google.com/?cid=1864871952288471669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "39.8305418",
      "poi_longitude": "-75.000917",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 856-346-4138",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfe4-72e5-8c26-403777192353",
        "storage_key": "property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEVuzsHPNxokRdVq--yhb4Rk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7e6bc28f-7654-40b2-b15d-0410a633d545",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health",
      "poi_address": "630 Chews Landing Rd, Lindenwold, NJ 08021, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-32af-731c-b4b3-bbee67b18ae7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-32af-731c-b4b3-bbee67b18ae7",
        "storage_key": "property/6767906449166315/019fcdf5-32af-731c-b4b3-bbee67b18ae7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-630+chews+landing+rd-lindenwold-nj-08021/id=3549",
      "poi_directions_map_url": "https://maps.google.com/?cid=2075529773501429586&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "39.8115483",
      "poi_longitude": "-75.0182694",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 856-566-0099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfe4-72e5-8c26-403777192353",
        "storage_key": "property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcSpP8HzSxokRUrdMFlXDzRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_78c1e0cc-01db-41d1-a74c-e4f373b25d91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Kennedy Pharmacy",
      "poi_type": "Health",
      "poi_address": "42 Laurel Rd #1900, Stratford, NJ 08084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-32cc-7457-9edb-387fdabffeb9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-32cc-7457-9edb-387fdabffeb9",
        "storage_key": "property/6767906449166315/019fcdf5-32cc-7457-9edb-387fdabffeb9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://kennedypharm.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5574728657182797518&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kennedy-pharmacy",
      "poi_latitude": "39.8308751",
      "poi_longitude": "-75.0066062",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 856-346-3535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-db7a-7778-87c9-36c4038c35b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-db7a-7778-87c9-36c4038c35b1",
        "storage_key": "property/6767906449166315/019d0265-db7a-7778-87c9-36c4038c35b1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh205InHNxokRzi6Sci1qXU0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9ffa7d59-9890-452c-89e4-3997d9044c35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health",
      "poi_address": "2005 NJ-70, Cherry Hill Township, NJ 08003, USA",
      "poi_short_description": "Chain gym offering a variety of fitness equipment, tanning services, and a massage chair.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-3541-71eb-bec2-9d7620a321f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-3541-71eb-bec2-9d7620a321f6",
        "storage_key": "property/6767906449166315/019fcdf5-3541-71eb-bec2-9d7620a321f6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/cherry-hill-route-70-east-nj?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=18205519147903621441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.8955179",
      "poi_longitude": "-74.95076809999999",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 856-751-9111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfe4-72e5-8c26-403777192353",
        "storage_key": "property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB5iEp6Y0wYkRQRleQjX_pvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_294658f9-186e-4dfd-8c20-fdb9c6e24954",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Cherry Hill Health & Racquet Club",
      "poi_type": "Health",
      "poi_address": "1820 Old Cuthbert Rd, Cherry Hill Township, NJ 08034, USA",
      "poi_short_description": "Sports club with state-of-the-art facilities offering a wide range of fitness classes and tennis courts.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-3609-7599-abd0-6bf51bd6282d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-3609-7599-abd0-6bf51bd6282d",
        "storage_key": "property/6767906449166315/019fcdf5-3609-7599-abd0-6bf51bd6282d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://chhrc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8882058147135098063&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cherry-hill-health--racquet-club",
      "poi_latitude": "39.9101934",
      "poi_longitude": "-74.9808611",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 856-208-6517",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfe4-72e5-8c26-403777192353",
        "storage_key": "property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS0MR2EXLxokRzwxaXtNoQ3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_859d4cec-6b2a-4e57-8ff9-52c87eef1e49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "HOTFLO Studios",
      "poi_type": "Health",
      "poi_address": "9107 Town Center Blvd, Voorhees Township, NJ 08043, USA",
      "poi_short_description": "Sweaty studio featuring a variety of classes led by skilled instructors.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-39dc-759c-b934-aa0e6eea851a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-39dc-759c-b934-aa0e6eea851a",
        "storage_key": "property/6767906449166315/019fcdf5-39dc-759c-b934-aa0e6eea851a.webp",
        "width": 1145,
        "height": 1280
      },
      "poi_business_url": "http://hotflostudios.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6773394955136179677&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotflo-studios",
      "poi_latitude": "39.85193040000001",
      "poi_longitude": "-74.9994607",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 856-888-1766",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d587-7418-be3a-d2c473e1c18e",
        "storage_key": "property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs6g4MQ_NxokR3Z1QINPu_10",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_955d1f06-0911-4251-aad4-83df1283f167",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Newton Lake Park",
      "poi_type": "Outdoor",
      "poi_address": "Haddon Township, NJ 08107, USA",
      "poi_short_description": "Pet-friendly neighborhood park with open fields & running/walking trails around a lake.",
      "poi_long_description": "Pet-friendly neighborhood park with open fields & running/walking trails around a lake.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-3a8a-7338-9c67-6765a0010849.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-3a8a-7338-9c67-6765a0010849",
        "storage_key": "property/6767906449166315/019fcdf5-3a8a-7338-9c67-6765a0010849.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.camdencounty.com/parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=16523622397898005226&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newton-lake-park",
      "poi_latitude": "39.9054734",
      "poi_longitude": "-75.064765",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 866-226-3362",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-db78-72de-8bc5-11c4713f739b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-db78-72de-8bc5-11c4713f739b",
        "storage_key": "property/6767906449166315/019d0265-db78-72de-8bc5-11c4713f739b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrQAEGKvOxokR6hpmZQazT-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_119410be-1ac8-4485-9a52-4b19ab8b02d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Haddon Lake Park",
      "poi_type": "Outdoor",
      "poi_address": "Mt Ephraim, NJ 08059, USA",
      "poi_short_description": "Waterside park featuring walking trails, playgrounds and fishing spots.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-3c61-76fe-b018-090985a4907b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-3c61-76fe-b018-090985a4907b",
        "storage_key": "property/6767906449166315/019fcdf5-3c61-76fe-b018-090985a4907b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4694567257373173407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "haddon-lake-park",
      "poi_latitude": "39.8859061",
      "poi_longitude": "-75.08492369999999",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-db78-72de-8bc5-11c4713f739b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-db78-72de-8bc5-11c4713f739b",
        "storage_key": "property/6767906449166315/019d0265-db78-72de-8bc5-11c4713f739b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSe1sKevOxokRn2boNQx0JkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_20fb8400-7ceb-4848-99eb-206d841df5c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "McLaughlin-Norcross Memorial Dell Haddon Lake Park",
      "poi_type": "Outdoor",
      "poi_address": "Haddon Township, NJ 08107, USA",
      "poi_short_description": "Big park with a lake for fishing & small boats, plus playgrounds, an amphitheater & softball field.",
      "poi_long_description": "Big park with a lake for fishing & small boats, plus playgrounds, an amphitheater & softball field.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-3d38-7328-8976-4be8577a8f18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-3d38-7328-8976-4be8577a8f18",
        "storage_key": "property/6767906449166315/019fcdf5-3d38-7328-8976-4be8577a8f18.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4582635427253154167&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mclaughlin-norcross-memorial-dell-haddon-lake-park",
      "poi_latitude": "39.8792197",
      "poi_longitude": "-75.07277859999999",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-db78-72de-8bc5-11c4713f739b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-db78-72de-8bc5-11c4713f739b",
        "storage_key": "property/6767906449166315/019d0265-db78-72de-8bc5-11c4713f739b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu7swLuvOxokRd3GLKKTKmD8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_141d48f1-253c-43c0-b586-fef6389b1a14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Saddler's Woods Conservation Association",
      "poi_type": "Outdoor",
      "poi_address": "250 MacArthur Blvd, Haddon Township, NJ 08108, USA",
      "poi_short_description": "Historic, well-preserved woodland featuring several trails, plus old trees.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-429c-7058-8e00-2762127cc4e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-429c-7058-8e00-2762127cc4e6",
        "storage_key": "property/6767906449166315/019fcdf5-429c-7058-8e00-2762127cc4e6.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.saddlerswoods.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5177359443764387318&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saddlers-woods-conservation-association",
      "poi_latitude": "39.9004522",
      "poi_longitude": "-75.0579566",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 856-869-7372",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-db78-72de-8bc5-11c4713f739b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-db78-72de-8bc5-11c4713f739b",
        "storage_key": "property/6767906449166315/019d0265-db78-72de-8bc5-11c4713f739b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ27k8mQHMxokR9h0XuPus2Uc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2279a748-2079-45e0-a3dc-ff7df54dad5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Somerdale Park School",
      "poi_type": "Outdoor",
      "poi_address": "301 Grace St, Somerdale, NJ 08083, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://somerdale-park.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7197602956515036298&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "somerdale-park-school",
      "poi_latitude": "39.8498172",
      "poi_longitude": "-75.02095659999999",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 856-783-6261",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d587-7418-be3a-d2c473e1c18e",
        "storage_key": "property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdV039qXNxokRikxhIcEF42M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8e0178f0-f71e-4964-afdb-77b5831c2b0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Crystal Springs Park",
      "poi_type": "Outdoor",
      "poi_address": "531 W Elma Ave, Laurel Springs, NJ 08021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-42f1-769c-b29d-4053338f1673.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-42f1-769c-b29d-4053338f1673",
        "storage_key": "property/6767906449166315/019fcdf5-42f1-769c-b29d-4053338f1673.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2395998570687730222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crystal-springs-park",
      "poi_latitude": "39.817246",
      "poi_longitude": "-75.00382909999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-db78-72de-8bc5-11c4713f739b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-db78-72de-8bc5-11c4713f739b",
        "storage_key": "property/6767906449166315/019d0265-db78-72de-8bc5-11c4713f739b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2dfXEADTxokRLpIvaAFMQCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3a1feb18-45c1-424e-b85f-e6738102de36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Lindenwold Memorial Park",
      "poi_type": "Outdoor",
      "poi_address": "Alkmonton Rd, Lindenwold, NJ 08021, USA",
      "poi_short_description": "Kid-friendly park featuring baseball fields and a playground.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-438b-72ef-ad6e-1b0944498760.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-438b-72ef-ad6e-1b0944498760",
        "storage_key": "property/6767906449166315/019fcdf5-438b-72ef-ad6e-1b0944498760.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://lindenwoldnj.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16329179064939874460&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lindenwold-memorial-park",
      "poi_latitude": "39.82045",
      "poi_longitude": "-74.96727899999999",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 856-783-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-db78-72de-8bc5-11c4713f739b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-db78-72de-8bc5-11c4713f739b",
        "storage_key": "property/6767906449166315/019d0265-db78-72de-8bc5-11c4713f739b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJL0woKq0ywYkRnIh8B9jlnOI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_df676bf4-6210-4689-868c-9788cc0079c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Cooper River Park",
      "poi_type": "Outdoor",
      "poi_address": "N Park Dr, Pennsauken, NJ 08109, USA",
      "poi_short_description": "Boat launch, picnic areas, mini-golf, bike paths & athletic fields in a scenic, riverside setting.",
      "poi_long_description": "Boat launch, picnic areas, mini-golf, bike paths & athletic fields in a scenic, riverside setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-44e6-753b-b288-c5fb6bdfad9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-44e6-753b-b288-c5fb6bdfad9c",
        "storage_key": "property/6767906449166315/019fcdf5-44e6-753b-b288-c5fb6bdfad9c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.camdencounty.com/service/parks/cooper-river-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17572809484733610672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cooper-river-park",
      "poi_latitude": "39.9246741",
      "poi_longitude": "-75.0595599",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 856-216-2117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-db78-72de-8bc5-11c4713f739b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-db78-72de-8bc5-11c4713f739b",
        "storage_key": "property/6767906449166315/019d0265-db78-72de-8bc5-11c4713f739b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJzaAjdF3JxokRsHopIx8p3_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_459ff7c9-cc43-409a-9de3-7b78988cca6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Lindenwold",
      "poi_type": "Transit",
      "poi_address": "901 Berlin Rd N, Lindenwold, NJ 08021, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-4ab5-765b-b72e-d5b1ae274902.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-4ab5-765b-b72e-d5b1ae274902",
        "storage_key": "property/6767906449166315/019fcdf5-4ab5-765b-b72e-d5b1ae274902.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ridepatco.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16081146720755170580&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lindenwold",
      "poi_latitude": "39.8339631",
      "poi_longitude": "-75.0006423",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-e127-7299-bf55-92622eb33e02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-e127-7299-bf55-92622eb33e02",
        "storage_key": "property/6767906449166315/019d0265-e127-7299-bf55-92622eb33e02.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJLR8XzW3NxokRFL2Mr721K98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_69fd0a4c-0591-4bc9-b7ba-4fc1d8fdc6b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Woodcrest",
      "poi_type": "Transit",
      "poi_address": "Cherry Hill Township, NJ 08003, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-4a68-742f-a5b2-9fb1779ea162.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-4a68-742f-a5b2-9fb1779ea162",
        "storage_key": "property/6767906449166315/019fcdf5-4a68-742f-a5b2-9fb1779ea162.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ridepatco.org/stations/woodcrest.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=1242536375377376350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodcrest",
      "poi_latitude": "39.8700839",
      "poi_longitude": "-75.0115141",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfe4-72e5-8c26-403777192353",
        "storage_key": "property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj_osC_fMxokRXrTeCkBgPhE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6a2e56b0-b00a-414e-9d44-3ea7e54f1a14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Westmont",
      "poi_type": "Transit",
      "poi_address": "100 Stoy Ave, Haddon Township, NJ 08108, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-4a54-744b-bba8-d7989869ae57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-4a54-744b-bba8-d7989869ae57",
        "storage_key": "property/6767906449166315/019fcdf5-4a54-744b-bba8-d7989869ae57.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ridepatco.org/stations/westmont.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=493636115030877118&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westmont",
      "poi_latitude": "39.9070623",
      "poi_longitude": "-75.046554",
      "poi_miles_from_property": "5.8 mi",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 856-772-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfe4-72e5-8c26-403777192353",
        "storage_key": "property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfdOMHffLxokRviO4ZG6_2QY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3b585315-5599-41a7-86b9-a736f8adcab3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Ferry Avenue",
      "poi_type": "Transit",
      "poi_address": "Camden, NJ 08103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-4be7-75d9-952e-4c78d82bf57c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-4be7-75d9-952e-4c78d82bf57c",
        "storage_key": "property/6767906449166315/019fcdf5-4be7-75d9-952e-4c78d82bf57c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.ridepatco.org/stations/ferryave.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=13193547021578846263&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ferry-avenue",
      "poi_latitude": "39.9225718",
      "poi_longitude": "-75.0918046",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfe4-72e5-8c26-403777192353",
        "storage_key": "property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJx9itzvJxokRN8CeHB3lGLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fc1b8a29-e455-43fb-a16f-0b67302a911b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Walter Rand Transportation Center",
      "poi_type": "Transit",
      "poi_address": "Camden, NJ 08103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-50e6-70d8-ba75-64888ef69cc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-50e6-70d8-ba75-64888ef69cc2",
        "storage_key": "property/6767906449166315/019fcdf5-50e6-70d8-ba75-64888ef69cc2.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "http://www.njtransit.com/rg/rg_servlet.srv?hdnPageAction=TrainStationLookupFrom&selStation=38307",
      "poi_directions_map_url": "https://maps.google.com/?cid=6124511133795613462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walter-rand-transportation-center",
      "poi_latitude": "39.943337",
      "poi_longitude": "-75.11853099999999",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-e187-720c-9467-ff546cd1ead4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-e187-720c-9467-ff546cd1ead4",
        "storage_key": "property/6767906449166315/019d0265-e187-720c-9467-ff546cd1ead4.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJQSNZs_rIxokRFvvPWG2i_lQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_023095c8-ed8b-422a-a799-fff246b43d45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Pennsauken Transit Center",
      "poi_type": "Transit",
      "poi_address": "315 Derousse Ave, Pennsauken, NJ 08110, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-514b-7178-80ce-348f30c1a980.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-514b-7178-80ce-348f30c1a980",
        "storage_key": "property/6767906449166315/019fcdf5-514b-7178-80ce-348f30c1a980.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.njtransit.com/station/pennsauken-transit-center-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=15596799152665299048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pennsauken-transit-center",
      "poi_latitude": "39.9778914",
      "poi_longitude": "-75.0608582",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 16 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 973-275-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-e181-74cf-aa40-e6ae2a65c746.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-e181-74cf-aa40-e6ae2a65c746",
        "storage_key": "property/6767906449166315/019d0265-e181-74cf-aa40-e6ae2a65c746.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJZWo-gwLKxokRaIi6pzH2ctg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_572711ed-467c-4c0f-ae7b-787139cad684",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Philadelphia International Airport",
      "poi_type": "Transit",
      "poi_address": "8500 Essington Ave, Philadelphia, PA 19153, USA",
      "poi_short_description": "Large hub with direct rail service, rotating art exhibitions & aviation-themed play areas for kids.",
      "poi_long_description": "Large hub with direct rail service, rotating art exhibitions & aviation-themed play areas for kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-51b0-74d5-a486-68fc06495c08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-51b0-74d5-a486-68fc06495c08",
        "storage_key": "property/6767906449166315/019fcdf5-51b0-74d5-a486-68fc06495c08.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.phl.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4480542405857629144&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "philadelphia-international-airport",
      "poi_latitude": "39.87297969999999",
      "poi_longitude": "-75.24369870000001",
      "poi_miles_from_property": "19.6 mi",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "2 hours 5 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 215-937-6937",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-e187-720c-9468-02d1ed7e36af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-e187-720c-9468-02d1ed7e36af",
        "storage_key": "property/6767906449166315/019d0265-e187-720c-9468-02d1ed7e36af.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJL4OpYGbExokR2NM3RpQVLj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_63b160e5-8b87-4904-bb82-68523ef33836",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Jefferson Stratford Hospital",
      "poi_type": "Offices",
      "poi_address": "18 Laurel Rd East, Stratford, NJ 08084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-2c35-7345-a36d-a5a08b0c1dac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-2c35-7345-a36d-a5a08b0c1dac",
        "storage_key": "property/6767906449166315/019fcdf5-2c35-7345-a36d-a5a08b0c1dac.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.jeffersonhealth.org/locations/stratford-hospital?utm_source=google&utm_medium=organic&utm_campaign=gbp-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17042968694022426207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-stratford-hospital",
      "poi_latitude": "39.8281678",
      "poi_longitude": "-75.00826599999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 856-346-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-db82-776b-97cb-d7e0dfecf4ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-db82-776b-97cb-d7e0dfecf4ef",
        "storage_key": "property/6767906449166315/019d0265-db82-776b-97cb-d7e0dfecf4ef.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZfXwCXrNxokRX05PzbrJhOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9cab76be-261b-4ab6-9b69-37cc2e71a68b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Rowan-Virtua School of Osteopathic Medicine",
      "poi_type": "Offices",
      "poi_address": "1 Medical Center Dr, Stratford, NJ 08084, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-527b-735c-ab60-ed82434a682e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-527b-735c-ab60-ed82434a682e",
        "storage_key": "property/6767906449166315/019fcdf5-527b-735c-ab60-ed82434a682e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://som.rowan.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13042685972299947075&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rowan-virtua-school-of-osteopathic-medicine",
      "poi_latitude": "39.82994410000001",
      "poi_longitude": "-75.0064775",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 856-566-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d587-7418-be3a-d2c473e1c18e",
        "storage_key": "property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFfCOiYLNxokRQ5zo58ntALU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2c1a1759-159c-4ac9-af1f-0678af0eb572",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Inspira Health Center Woodbury",
      "poi_type": "Offices",
      "poi_address": "509 N Broad St, Woodbury, NJ 08096, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-58a2-709c-bc1e-54cde6a5f11f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-58a2-709c-bc1e-54cde6a5f11f",
        "storage_key": "property/6767906449166315/019fcdf5-58a2-709c-bc1e-54cde6a5f11f.webp",
        "width": 1280,
        "height": 736
      },
      "poi_business_url": "https://www.inspirahealthnetwork.org/locations/inspira-health-center-woodbury",
      "poi_directions_map_url": "https://maps.google.com/?cid=2170008355021517448&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "inspira-health-center-woodbury",
      "poi_latitude": "39.8435878",
      "poi_longitude": "-75.15082509999999",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 856-845-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-db82-776b-97cb-d7e0dfecf4ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-db82-776b-97cb-d7e0dfecf4ef",
        "storage_key": "property/6767906449166315/019d0265-db82-776b-97cb-d7e0dfecf4ef.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJPcNKC_nPxokRiPKvCBprHR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9f11f0f8-e0a4-45c2-a0d2-fcb4ffc683a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Virtua Voorhees Hospital",
      "poi_type": "Offices",
      "poi_address": "100 Bowman Dr, Voorhees Township, NJ 08043, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-2dc3-766f-93ea-9ebd7bfad2d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-2dc3-766f-93ea-9ebd7bfad2d6",
        "storage_key": "property/6767906449166315/019fcdf5-2dc3-766f-93ea-9ebd7bfad2d6.webp",
        "width": 1280,
        "height": 1260
      },
      "poi_business_url": "https://www.virtua.org/locations/voorhees-hospital?utm_source=local&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13922560869268213923&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "virtua-voorhees-hospital",
      "poi_latitude": "39.84165369999999",
      "poi_longitude": "-74.9270074",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 856-247-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-db82-776b-97cb-d7e0dfecf4ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-db82-776b-97cb-d7e0dfecf4ef",
        "storage_key": "property/6767906449166315/019d0265-db82-776b-97cb-d7e0dfecf4ef.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVW1Q0S8zwYkRo1B8gFjfNsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_581d2f1e-ab79-4453-b118-f8a5e4b15919",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Cooper University Hospital",
      "poi_type": "Offices",
      "poi_address": "1 Cooper Plaza, Camden, NJ 08103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-5867-71f0-a21d-446cd62f824b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-5867-71f0-a21d-446cd62f824b",
        "storage_key": "property/6767906449166315/019fcdf5-5867-71f0-a21d-446cd62f824b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.cooperhealth.org/?utm_source=google&utm_medium=organic&utm_campaign=google_my_business",
      "poi_directions_map_url": "https://maps.google.com/?cid=680027330547190836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cooper-university-hospital",
      "poi_latitude": "39.9416173",
      "poi_longitude": "-75.1171062",
      "poi_miles_from_property": "9.4 mi",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 856-342-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-db82-776b-97cb-d7e0dfecf4ef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-db82-776b-97cb-d7e0dfecf4ef",
        "storage_key": "property/6767906449166315/019d0265-db82-776b-97cb-d7e0dfecf4ef.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1-ECnOTIxokRNIzSEkHxbwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_915d5e64-bbb8-4f8d-b7df-4f46c21fc914",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Campus Center",
      "poi_type": "Offices",
      "poi_address": "326 Penn St, Camden, NJ 08102, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-58c8-70cc-a809-a7b42bd244cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-58c8-70cc-a809-a7b42bd244cd",
        "storage_key": "property/6767906449166315/019fcdf5-58c8-70cc-a809-a7b42bd244cd.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://campuscenter.camden.rutgers.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8845773331989590321&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "campus-center",
      "poi_latitude": "39.9480727",
      "poi_longitude": "-75.1224895",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 856-225-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfe4-72e5-8c26-403777192353",
        "storage_key": "property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj9_2J_HIxokRMfHcgPp_wno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a85f0081-b94a-4ff9-a4eb-4c49fdfe66af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Camden County College",
      "poi_type": "Offices",
      "poi_address": "200 College Dr, Blackwood, NJ 08012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-1924-708d-8af0-2023a99856e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-1924-708d-8af0-2023a99856e2",
        "storage_key": "property/6767906449166315/019fcdf5-1924-708d-8af0-2023a99856e2.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.camdencc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17527533757141958008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camden-county-college",
      "poi_latitude": "39.78447600000001",
      "poi_longitude": "-75.03720349999999",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 856-227-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-d587-7418-be3a-d2c473e1c18e",
        "storage_key": "property/6767906449166315/019d0265-d587-7418-be3a-d2c473e1c18e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUVFtsDXSxokReD0dVxZPPvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_072ce0b6-b715-4ce4-8d0e-2c9d5f2df5c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "The Campbell's Company",
      "poi_type": "Offices",
      "poi_address": "1 Campbell Pl, Camden, NJ 08103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-5937-72d2-b82f-5dfddb04fa85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-5937-72d2-b82f-5dfddb04fa85",
        "storage_key": "property/6767906449166315/019fcdf5-5937-72d2-b82f-5dfddb04fa85.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "http://www.campbellsoupcompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9404095504793662939&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-campbells-company",
      "poi_latitude": "39.9395481",
      "poi_longitude": "-75.1083244",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 27 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 800-257-8443",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfe4-72e5-8c26-403777192353",
        "storage_key": "property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmd3NhOLIxokR2_USXQkPgoI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fe21e276-a2bb-42e2-950e-1d54bcc95403",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Camden County Hall of Justice",
      "poi_type": "Offices",
      "poi_address": "101 S 5th St, Camden, NJ 08103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-5f96-7613-b11c-bc317b176564.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-5f96-7613-b11c-bc317b176564",
        "storage_key": "property/6767906449166315/019fcdf5-5f96-7613-b11c-bc317b176564.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.camdencounty.com/maps-directions",
      "poi_directions_map_url": "https://maps.google.com/?cid=5861826946034909831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camden-county-hall-of-justice",
      "poi_latitude": "39.9431738",
      "poi_longitude": "-75.122467",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 856-650-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-e782-74e9-8ec3-b82a5bcd3082.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-e782-74e9-8ec3-b82a5bcd3082",
        "storage_key": "property/6767906449166315/019d0265-e782-74e9-8ec3-b82a5bcd3082.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBeURM-7IxokRh0I51YxkWVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ac01adf1-8836-4a8a-a14a-f937e3dbd1b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "poi_name": "Subaru of America",
      "poi_type": "Offices",
      "poi_address": "1 Subaru Dr, Camden, NJ 08103, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf5-5f85-7317-8f9d-05c9937b12d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf5-5f85-7317-8f9d-05c9937b12d4",
        "storage_key": "property/6767906449166315/019fcdf5-5f85-7317-8f9d-05c9937b12d4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.subaru.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7949239964005152156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "subaru-of-america",
      "poi_latitude": "39.942594",
      "poi_longitude": "-75.108339",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 800-782-2783",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0265-cfe4-72e5-8c26-403777192353",
        "storage_key": "property/6767906449166315/019d0265-cfe4-72e5-8c26-403777192353.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgzfHteLIxokRnLXdYKFfUW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_e61a0545-88ce-4701-affb-910363d8ca70",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_7d7f4064-7885-4cd1-b2f9-ff265f4f3bf6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f186a2b9-7690-4f77-8447-c3bfef4935d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_a2716d72-f15f-4358-904d-9ac374bdd450",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d7ea9f2d-1c24-4807-94f1-2674530e30ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_51e218b8-2182-4f84-9a5c-d5027f6dd7a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_2b6c8ae1ac2a396902476972",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "rating": "5",
      "name": "Mya Jones",
      "text": "Terik & John are fantastic. John showed me around and did my tours of the apartment complex, and Terik orchestrated everything concerning my application, lease, and move in date.\n\nThey both made it extremely easy and whenever I had questions, which I did, because I am a first time renter, I called and they gladly answered all of them with patience.\n\nI had a brief interaction with one member of the maintenance team, as there was a small hiccup at move in, and they beat me to my apartment and resolved the issue. 10/10 recommend to anyone looking for an apartment complex that feels like. community.",
      "date": "2025-09-24",
      "title": "false"
    },
    {
      "id": "ec_56239646bd280bb0df4e489f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "rating": "5",
      "name": "Jashina Reynoso",
      "text": "5 Stars - Highly Recommend!\n\nI’ve had a great experience living at Fox Pointe! From the moment I applied, everything has been smooth and stress-free. I have to give a special shoutout to Ashley—she made the entire move-in process so easy and welcoming. She was super helpful, responsive, and made sure I had everything I needed from day one.\n\nThe maintenance team is excellent—they respond quickly, handle requests professionally, and truly care about keeping the property in great shape. It’s such a relief knowing that if anything goes wrong, it’ll be taken care of fast and correctly.\n\nOverall, Fox Pointe feels like home. The staff is friendly, the community is quiet and clean, and I’m really happy I chose to live here!",
      "date": "2025-05-12",
      "title": "false"
    },
    {
      "id": "ec_888122cb6ad4aa180ace4cf5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "rating": "5",
      "name": "Salman Aqib",
      "text": "I had an amazing time at Fox Pointe apartment! The leasing office staff especially Tarik & Melissa and maintenance team were incredibly helpful and attentive throughout my stay. They made everything seamless and ensured any issues were promptly addressed. It was one of the wonderful places I ever lived. I highly recommend this community to anyone seeking a fantastic living experience. Thank you for everything!",
      "date": "2024-05-03",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_df8de39a-1ccf-4f38-b275-4ad3cae4774c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-b4de-770a-b877-6a4399cfdb00.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Dining area with table and chairs, leading to a kitchen and a sliding door with a view of the outdoors.",
        "public_id": "019fcdf4-b4de-770a-b877-6a4399cfdb00",
        "storage_key": "property/6767906449166315/019fcdf4-b4de-770a-b877-6a4399cfdb00.webp",
        "width": 1920,
        "height": 1278
      },
      "virtual_tour_title": " Fox Pointe - Unit Tours",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://app.cloudpano.com/group/X_hmo6d3F"
    },
    {
      "id": "custom_ce56341d-a3f3-4079-a83e-3ced1a9031ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019e8206-3c1b-7407-8105-a4a0b7e054b7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e8206-3c1b-7407-8105-a4a0b7e054b7",
        "storage_key": "property/6767906449166315/019e8206-3c1b-7407-8105-a4a0b7e054b7.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=634f24a721e985696bdd79d5&sourceId=1001"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_bf5936217e9e1a40273dd33a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "engrain",
      "external_id": "429420",
      "name": "Admin Fee",
      "description": "false",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1014850b5643d83687dd8d2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "engrain",
      "external_id": "429421",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_372fc4a8864244fcd81dcf3d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "engrain",
      "external_id": "429422",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_25691e42b990936382235c53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "engrain",
      "external_id": "429423",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_9ef66d187b60ba56fc1f1931",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "engrain",
      "external_id": "429424",
      "name": "Pet Fee",
      "description": "One-time fee of $350 covers up to 2 pets.",
      "amount": 400,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6cc73b248018f8f56d555052",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "engrain",
      "external_id": "429426",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "50.00 / 25.00",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_72b7de05b5acd8f8023ce6e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "engrain",
      "external_id": "429428",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8a053a9489f8e52a5a0c53a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "engrain",
      "external_id": "429429",
      "name": "Transfer Fee",
      "description": "false",
      "amount": 500,
      "amount_max": 1000,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e00f883e910a8fe613eb6847",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "engrain",
      "external_id": "480343",
      "name": "Annual Fitness Center Fee",
      "description": "false",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Annually, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_ea46286b5e93bc387bcbf851",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "engrain",
      "external_id": "536737",
      "name": "Trash Service",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6bf630da83859b8bfed1063e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "engrain",
      "external_id": "536738",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_af81356607755ac20258e96a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "engrain",
      "external_id": "536739",
      "name": "Utility - Administrative Billing Fee",
      "description": "false",
      "amount": 4.66,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_936ba3979c247686b5476587",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "engrain",
      "external_id": "543091",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_eee0354619ed4ee1785f0545",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "engrain",
      "external_id": "543095",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_0cf15be93e519fb1fed00046",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "engrain",
      "external_id": "543098",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_64099e19b931143b8dee642f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "engrain",
      "external_id": "832504",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_efc305334955398b818163e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "engrain",
      "external_id": "832505",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_05efe2c655773102702a3367",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "engrain",
      "external_id": "832506",
      "name": "Monthly Fitness Center Fee",
      "description": "false",
      "amount": 8,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4bbe6bfe43de5e8d385a7ccc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "engrain",
      "external_id": "832511",
      "name": "Late Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per occurrence",
      "category": "penalties",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_957a844ddc846f9169f2cb63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "engrain",
      "external_id": "832516",
      "name": "Annual Pool Fee",
      "description": "false",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Annually",
      "category": "community",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4c9ec9a4c5abdd5a849ef3f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "engrain",
      "external_id": "832523",
      "name": "Lockout Fee - After Hours",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a12f4-c09f-7289-bc32-a55ef4ca9be4",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-fox-pointe-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315"
    },
    {
      "lead_collector_id": "019c3043-4807-71cd-a797-f3a258ed6236",
      "lead_source": "FACEBOOK_ADS",
      "name": "fox-pointe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315"
    },
    {
      "lead_collector_id": "019c3043-487b-7525-8883-368d7667f172",
      "lead_source": "LANDING_PAGE",
      "name": "fox-pointe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-hi-nella-nj-561",
      "search_query": "pet friendly apartments Hi-Nella NJ",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Hi-Nella, NJ",
      "h2_subtitle": "Discover pet-friendly living in Hi-Nella, NJ at Fox Pointe. Enjoy amenities like EV charging and a swimming pool in a welcoming community.",
      "page_copy": "Finding the perfect home for you and your furry friend is easy at Fox Pointe, where pet friendly apartments in Hi-Nella, NJ offer a warm welcome to all residents. Whether you choose a one, two, or three-bedroom layout, you're guaranteed a comfortable living space complemented by modern amenities like a fitness center and a serene swimming pool.\n\nEmbrace a lifestyle that provides convenience and leisure in a pet-friendly environment. Your four-legged companions will love the scenic picnic area, while you enjoy the perks of flex rent payments and in-unit stackable washers and dryers. At Fox Pointe, located in vibrant Camden County, experience a community that truly feels like home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Hi-Nella, NJ",
      "seo_description": "Find pet-friendly living at Fox Pointe, Hi-Nella, NJ. Modern amenities & spacious floor plans make it the perfect home for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "apartments-swimming-pool-camden-county-507",
      "search_query": "apartments with swimming pool Camden County",
      "category": "Amenity",
      "h1_title": "Apartments with Swimming Pool in Camden County",
      "h2_subtitle": "Enjoy luxury living at Fox Pointe with a swimming pool in Camden County. Our community offers modern amenities for an active lifestyle.",
      "page_copy": "Dive into comfort at Fox Pointe, where our apartments with a swimming pool in Camden County provide an ideal setting for leisure and relaxation. Our community features a top-notch swimming pool where residents can unwind and soak up the sun, making everyday feel like a vacation.\n\nBeyond the pool, Fox Pointe offers a selection of one to three-bedroom apartments, each enhanced with modern amenities such as a fitness center and stackable washers and dryers. Enjoy living in a community that supports active and vibrant lifestyles with pet-friendly policies, EV charging stations, and flexible rent payment options, right in the heart of Hi-Nella, NJ.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Swimming Pool in Camden County",
      "seo_description": "Discover Fox Pointe, Hi-Nella: Camden County apartments with a swimming pool and modern amenities. Enjoy active living in our welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "ev-charging-station-apartments-08083-367",
      "search_query": "EV charging station apartments 08083",
      "category": "Amenity",
      "h1_title": "EV Charging Station Apartments in 08083",
      "h2_subtitle": "Fox Pointe offers EV charging station apartments in 08083. Embrace a modern lifestyle with eco-friendly amenities here in Hi-Nella.",
      "page_copy": "At Fox Pointe, residents enjoy EV charging station apartments in the heart of Hi-Nella, NJ, within the 08083 ZIP code. These forward-thinking amenities make sustainable living easy and convenient for electric vehicle owners. Living at Fox Pointe means you have access to a cutting-edge feature right at home.\n\nFox Pointe isn't just about green living. Our community features a range of modern conveniences including a fitness center and swimming pool, alongside spacious one to three-bedroom floor plans. The exceptional pet-friendly environment, complete with a picnic area and advanced in-unit features like stackable washers and dryers, ensure that you and your furry friends can truly thrive.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "EV Charging Station Apartments in 08083",
      "seo_description": "Find Fox Pointe, Hi-Nella: apartments with EV charging stations and modern features in the 08083 area. A perfect blend of convenience and sustainability.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "fitness-center-apartment-rentals-hi-nella-451",
      "search_query": "fitness center apartment rentals Hi-Nella",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartment Rentals in Hi-Nella",
      "h2_subtitle": "Fox Pointe offers fitness center apartment rentals in Hi-Nella, NJ. Stay active with onsite amenities designed for a healthy lifestyle.",
      "page_copy": "Living at Fox Pointe means having access to top-notch fitness center apartment rentals in Hi-Nella. Our modern and fully-equipped fitness center empowers residents to achieve their health goals without leaving home, making it a convenient choice for those seeking an active lifestyle.\n\nBeyond fitness, Fox Pointe boasts a variety of amenities including a refreshing swimming pool and a welcoming pet-friendly environment. Choose from one to three-bedroom floor plans that offer style and comfort, complete with stackable washers and dryers. Enjoy the added convenience of EV charging stations and flexible rent payment options, all within a vibrant Camden County community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartment Rentals in Hi-Nella",
      "seo_description": "Discover Fox Pointe, Hi-Nella: apartment rentals with a fitness center. Embrace an active lifestyle with modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "modern-renovated-kitchens-camden-county-711",
      "search_query": "modern renovated kitchens in Camden County",
      "category": "Amenity",
      "h1_title": "Modern Renovated Kitchens in Camden County",
      "h2_subtitle": "Fox Pointe features apartments with modern renovated kitchens in Camden County. Experience style and functionality in every home.",
      "page_copy": "Experience the allure of modern renovated kitchens at Fox Pointe, positioned conveniently in Camden County. Our apartments are designed with upgraded kitchens that boast contemporary finishes and practical layouts, making cooking a delightful experience.\n\nAside from these sleek kitchen spaces, Fox Pointe provides an ideal living environment with amenities like a fitness center and swimming pool. Choose from our range of spacious one to three-bedroom floor plans, each ready with cable and satellite TV, stackable washers and dryers, and more. Enjoy the benefits of a pet-friendly community with EV charging and flexible rent options in Hi-Nella, NJ.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Renovated Kitchens in Camden County",
      "seo_description": "Explore Fox Pointe, Hi-Nella: apartments with modern renovated kitchens in Camden County. Enjoy style and convenience in your perfect home.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-hi-nella-nj-788",
      "search_query": "one bedroom apartments in Hi-Nella NJ",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Hi-Nella, NJ",
      "h2_subtitle": "Discover spacious one bedroom apartments in Hi-Nella, NJ at Fox Pointe. Stylish living with modern amenities awaits.",
      "page_copy": "Welcome to Fox Pointe, where our spacious one bedroom apartments in Hi-Nella, NJ, provide the perfect blend of comfort and modern style. Every unit is designed with the resident in mind, offering a cozy yet sophisticated living experience in a vibrant community.\n\nResidents enjoy an array of amenities, including a fully-equipped fitness center and a refreshing swimming pool. Our community is pet-friendly and features conveniences such as stackable washers and dryers, flex rent payments, and EV charging stations. Located in Camden County, Fox Pointe elevates apartment living with its balance of style, function, and excellent location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Hi-Nella, NJ",
      "seo_description": "Discover Fox Pointe, Hi-Nella: spacious one bedroom apartments with modern amenities in a vibrant community. Experience comfortable living in NJ.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-camden-county-277",
      "search_query": "two bedroom apartments Camden County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Camden County",
      "h2_subtitle": "Find stunning two bedroom apartments in Camden County at Fox Pointe. Enjoy ample space and modern amenities in Hi-Nella.",
      "page_copy": "Fox Pointe offers exceptional two bedroom apartments in Camden County that are perfect for a variety of lifestyles. Located in Hi-Nella, our apartments provide ample living space with modern amenities designed to enhance your everyday living experience. \n\nResidents of Fox Pointe can enjoy features like a state-of-the-art fitness center, a refreshing swimming pool, and beautifully landscaped picnic areas. Each apartment comes equipped with stackable washers and dryers, and residents have options like flex rent payments. Our community is pet-friendly and includes the convenience of EV charging stations, making it an ideal choice for contemporary living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Camden County",
      "seo_description": "Discover Fox Pointe: spacious two bedroom apartments with modern amenities in Camden County, Hi-Nella. Perfect for comfortable, stylish living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-08083-102",
      "search_query": "three bedroom apartments near 08083",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 08083",
      "h2_subtitle": "Explore spacious three bedroom apartments near 08083 at Fox Pointe. Make Hi-Nella your new home with modern amenities.",
      "page_copy": "Fox Pointe presents an unbeatable opportunity with its three bedroom apartments near the 08083 area. Designed to cater to families or those in need of extra space, our apartments offer comfort, style, and a perfect location. \n\nLiving at Fox Pointe means enjoying features like a top-notch fitness center, a community swimming pool, and a picnic area for gatherings. Each apartment is outfitted with stackable washers and dryers, ensuring convenience, while our pet-friendly policy and EV charging facilities make life even easier. Located in Hi-Nella, NJ, Fox Pointe is where your spacious and well-appointed home awaits.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 08083",
      "seo_description": "Find spacious three bedroom apartments near 08083 at Fox Pointe. Enjoy modern amenities and a welcoming community in Hi-Nella, NJ.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "apartments-near-parkview-elementary-hi-nella-516",
      "search_query": "apartments near parkview elementary school hi-nella",
      "category": "School",
      "h1_title": "Apartments Near Parkview Elementary School",
      "h2_subtitle": "Discover beautiful apartments near Parkview Elementary School in Hi-Nella at Fox Pointe. Enjoy convenience and a thriving community.",
      "page_copy": "Fox Pointe is the ideal choice for families seeking apartments near Parkview Elementary School in Hi-Nella. Our community ensures a short and easy commute to ensure more quality family time while offering spacious floor plans and a welcoming environment. \n\nOur community in Camden County features amenities such as a modern fitness center, a swimming pool, and a charming picnic area. Each apartment includes stackable washers and dryers for ease of living, and flex rent payments are available. With a pet-friendly policy and EV charging stations, Fox Pointe caters to modern needs while keeping close to Parkview Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Parkview Elementary School",
      "seo_description": "Find Fox Pointe: apartments near Parkview Elementary School in Hi-Nella, offering family-friendly amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "fox-pointe-by-samuel-yellin-school-235",
      "search_query": "fox pointe apartments by samuel s yellin school camden county",
      "category": "School",
      "h1_title": "Fox Pointe Apartments Near Samuel S. Yellin School",
      "h2_subtitle": "Discover Fox Pointe Apartments near Samuel S. Yellin School in Camden County. Ideal location with modern amenities awaits you.",
      "page_copy": "Fox Pointe Apartments offer a perfect home for families who want proximity to Samuel S. Yellin School in Camden County. Our community not only provides convenient access but also invites you to experience stylish and comfortable living in Hi-Nella.\n\nResidents at Fox Pointe enjoy amenities including a fully-equipped fitness center, a sparkling swimming pool, and a peaceful picnic area. Our apartments are cable and satellite ready, featuring stackable washers and dryers for convenience. Being a pet-friendly community with EV charging options, Fox Pointe caters to contemporary lifestyles while being close to great schools such as Samuel S. Yellin.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fox Pointe Apartments Near Samuel S. Yellin School",
      "seo_description": "Explore Fox Pointe Apartments near Samuel S. Yellin School in Camden County. Enjoy modern amenities and an ideal location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "sterling-high-school-nearby-hi-nella-nj-apartments-825",
      "search_query": "sterling high school nearby hi-nella nj apartments",
      "category": "School",
      "h1_title": "Hi-Nella NJ Apartments Near Sterling High School",
      "h2_subtitle": "Discover apartments in Hi-Nella, NJ, near Sterling High School. Experience convenient living with modern amenities at Fox Pointe.",
      "page_copy": "Fox Pointe offers desirable Hi-Nella, NJ apartments conveniently located near Sterling High School. Perfect for families, our community ensures easy access to education and enhances daily living with attractive amenities.\n\nExperience a blend of comfort and style with spacious floor plans, a state-of-the-art fitness center, and a refreshing swimming pool. Our community also features a picnic area and pet-friendly accommodations, along with stackable washers and dryers in each apartment. Choose Fox Pointe for its prime location near Sterling High School and enjoy the vibrant life Camden County offers.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sterling High School Hi-Nella NJ",
      "seo_description": "Live at Fox Pointe: Hi-Nella NJ apartments near Sterling High School. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "apartments-close-to-somerdale-park-school-08083-389",
      "search_query": "apartments close to somerdale park school 08083",
      "category": "School",
      "h1_title": "Apartments Close to Somerdale Park School",
      "h2_subtitle": "Find ideal apartments close to Somerdale Park School in the 08083 area. Fox Pointe offers great amenities in a convenient location.",
      "page_copy": "Located in the heart of Camden County, Fox Pointe provides apartments close to Somerdale Park School in the 08083 area. Perfect for families looking to minimize commuting, our community is full of vibrancy and convenience.\n\nFox Pointe ensures a comfortable lifestyle with amenities like a modern fitness center, swimming pool, and cozy picnic area. Each apartment is cable and satellite ready, and includes stackable washers and dryers. With flexible rent payments and a pet-friendly policy, Fox Pointe is the perfect home base close to quality education at Somerdale Park School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Somerdale Park School 08083",
      "seo_description": "Discover Fox Pointe Apartments near Somerdale Park School in the 08083 area. Enjoy convenient living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "saint-john-paul-ii-school-near-hi-nella-apartments-998",
      "search_query": "saint john paul ii regional school near hi-nella apartments",
      "category": "School",
      "h1_title": "Hi-Nella Apartments Near Saint John Paul II School",
      "h2_subtitle": "Explore Hi-Nella apartments conveniently near Saint John Paul II Regional School. Enjoy modern living with easy school access.",
      "page_copy": "Fox Pointe, nestled in the vibrant community of Hi-Nella, offers convenient living near Saint John Paul II Regional School. Known for its family-friendly atmosphere, our community provides easy access to education and a comfortable lifestyle.\n\nResidents of Fox Pointe can indulge in a variety of modern amenities, including a full-equipped fitness center, a relaxing swimming pool, and pet-friendly spaces. Each apartment comes with stackable washers and dryers, and is cable and satellite ready, ensuring convenience at your fingertips. Make Fox Pointe your home and enjoy easy proximity to Saint John Paul II Regional School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hi-Nella Apartments Near Saint John Paul II School",
      "seo_description": "Choose Fox Pointe: Hi-Nella apartments near Saint John Paul II Regional School with great amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "camden-county-college-apartments-fox-pointe-hi-nella-642",
      "search_query": "camden county college apartments fox pointe hi-nella",
      "category": "School",
      "h1_title": "Fox Pointe Apartments Near Camden County College",
      "h2_subtitle": "Discover Fox Pointe, ideal apartments near Camden County College in Hi-Nella. Enjoy student-friendly amenities and a convenient location.",
      "page_copy": "Fox Pointe in Hi-Nella offers the perfect living solution for students seeking apartments near Camden County College. Our community combines comfort and convenience, providing easy access to education and a vibrant lifestyle.\n\nEnjoy a host of amenities tailored for modern living, including a fitness center, a sparkling swimming pool, and flexible rent payment options. Each apartment is equipped with a stackable washer and dryer, cable and satellite readiness, and welcomes pets. Make your college experience stress-free with Fox Pointe's prime location and exceptional living environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Camden County College Fox Pointe",
      "seo_description": "Find student-friendly living at Fox Pointe, Hi-Nella! Apartments near Camden County College with great amenities and location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "apartments-near-jefferson-stratford-hospital-nj-964",
      "search_query": "apartments near Jefferson Stratford Hospital NJ",
      "category": "Hospital",
      "h1_title": "Apartments Near Jefferson Stratford Hospital",
      "h2_subtitle": "Discover Fox Pointe, offering comfortable apartments near Jefferson Stratford Hospital, NJ. Enjoy proximity and convenience.",
      "page_copy": "Fox Pointe in Hi-Nella provides an excellent living choice for those seeking apartments near Jefferson Stratford Hospital, NJ. Our community offers convenient access to healthcare facilities while immersing you in a comfortable, amenity-rich environment.\n\nResidents can enjoy a modern fitness center, a refreshing swimming pool, and a welcoming picnic area. Each apartment features stackable washers and dryers, is cable and satellite ready, and allows pets. Experience the perfect blend of convenience and comfort by choosing Fox Pointe as your new home near Jefferson Stratford Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Jefferson Stratford Hospital, NJ",
      "seo_description": "Choose Fox Pointe for apartments near Jefferson Stratford Hospital, NJ. Enjoy modern amenities and convenient access to healthcare.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "fox-pointe-proximity-to-virtua-voorhees-hospital-861",
      "search_query": "Fox Pointe proximity to Virtua Voorhees Hospital",
      "category": "Hospital",
      "h1_title": "Fox Pointe Near Virtua Voorhees Hospital",
      "h2_subtitle": "Live at Fox Pointe, close to Virtua Voorhees Hospital. Enjoy convenient access and a vibrant community.",
      "page_copy": "Located in Hi-Nella, Fox Pointe is an ideal residence offering proximity to Virtua Voorhees Hospital. This makes our community a perfect fit for healthcare professionals and anyone seeking quick access to medical facilities.\n\nFox Pointe combines convenience with comfort, featuring modern amenities such as a fitness center, a sparkling swimming pool, and flexible rent payment options. Apartments are equipped with stackable washers and dryers, set up for cable and satellite, and accommodate pets, ensuring a hassle-free lifestyle. Experience quality living near Virtua Voorhees Hospital at Fox Pointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fox Pointe Near Virtua Voorhees Hospital",
      "seo_description": "Experience Fox Pointe, offering a prime location near Virtua Voorhees Hospital, with modern amenities and a supportive community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "apartments-close-to-jefferson-stratford-hospital-camden-county-638",
      "search_query": "apartments close to Jefferson Stratford Hospital Camden County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Jefferson Stratford Hospital",
      "h2_subtitle": "Explore Fox Pointe, offering apartments close to Jefferson Stratford Hospital in Camden County. Enjoy unparalleled convenience and comfort.",
      "page_copy": "Fox Pointe in Hi-Nella is the ideal choice for those seeking apartments in Camden County, close to Jefferson Stratford Hospital. Our location offers unparalleled convenience for healthcare workers and patients who need easy access to medical services.\n\nResidents will find plenty of amenities designed for a convenient lifestyle, including a fitness center, swimming pool, and convenient flex rent payment options. Each apartment comes equipped with stackable washers and dryers, is cable and satellite ready, and welcomes pets. Experience a seamless blend of convenience and community at Fox Pointe near Jefferson Stratford Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Jefferson Stratford Hospital Camden",
      "seo_description": "Find Fox Pointe apartments in Camden County, close to Jefferson Stratford Hospital. Enjoy convenience and a vibrant lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "apartments-near-newton-lake-park-hi-nella-nj-326",
      "search_query": "apartments near newton lake park hi nella nj",
      "category": "Park",
      "h1_title": "Apartments Near Newton Lake Park, Hi-Nella",
      "h2_subtitle": "Explore Fox Pointe, with apartments near Newton Lake Park in Hi-Nella, NJ. Enjoy nature and modern living.",
      "page_copy": "Fox Pointe offers exceptional living in Hi-Nella, NJ, featuring apartments near the serene Newton Lake Park. Enjoy the perfect blend of nature and modern amenities, making it a great choice for outdoor enthusiasts and families alike.\n\nOur community includes a range of stylish upgrades and amenities such as a fitness center, swimming pool, and pet-friendly accommodations. Apartments are equipped with stackable washers and dryers, cable and satellite readiness, and flexible rent payments. Embrace a lifestyle where nature meets comfort at Fox Pointe near Newton Lake Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Newton Lake Park Hi-Nella, NJ",
      "seo_description": "Discover Fox Pointe, offering apartments near Newton Lake Park in Hi-Nella, NJ. Experience modern living close to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "fox-pointe-close-to-haddon-lake-park-08083-384",
      "search_query": "fox pointe close to haddon lake park 08083",
      "category": "Park",
      "h1_title": "Fox Pointe Near Haddon Lake Park",
      "h2_subtitle": "Discover Fox Pointe's proximity to Haddon Lake Park in the 08083 area. Enjoy scenic beauty and community.",
      "page_copy": "Located in the heart of Hi-Nella, NJ, Fox Pointe offers the perfect location for those wishing to be close to Haddon Lake Park. Our community is ideal for nature lovers who appreciate the tranquility and recreation opportunities nearby.\n\nAt Fox Pointe, you'll find a wide array of amenities designed for modern living. From a well-equipped fitness center and a sparkling swimming pool to pet-friendly policies and EV charging options, comfort is paramount. Each apartment features stackable washers and dryers, cable and satellite readiness, and the flexibility of rent payments, ensuring a delightful living experience close to Haddon Lake Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fox Pointe Near Haddon Lake Park 08083",
      "seo_description": "Experience modern living at Fox Pointe, close to Haddon Lake Park in 08083. Enjoy nature alongside premier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "hi-nella-nj-apartments-near-mclaughlin-norcross-memorial-dell-804",
      "search_query": "hi nella nj apartments near mclaughlin-norcross memorial dell",
      "category": "Park",
      "h1_title": "Hi-Nella Apartments Near McLaughlin-Norcross Dell",
      "h2_subtitle": "Fox Pointe offers Hi-Nella, NJ apartments near the scenic McLaughlin-Norcross Memorial Dell, blending comfort with nature.",
      "page_copy": "For those seeking Hi-Nella, NJ apartments near the beautiful McLaughlin-Norcross Memorial Dell, Fox Pointe provides an ideal home base. Our community combines convenience with lush surroundings, making it an attractive choice for nature enthusiasts and anyone who loves outdoor adventures.\n\nFox Pointe boasts amenities such as a state-of-the-art fitness center, a swimming pool, and a welcoming atmosphere for pets. Each apartment is equipped with stackable washers and dryers, is cable and satellite ready, and offers flex rent payment options. Discover a seamless mix of comfort and convenience at Fox Pointe, just moments from McLaughlin-Norcross Memorial Dell.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hi-Nella Apartments Near McLaughlin-Norcross Dell",
      "seo_description": "Find Fox Pointe in Hi-Nella, NJ, offering apartments near McLaughlin-Norcross Memorial Dell. Enjoy nature and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "apartments-near-saddlers-woods-camden-county-850",
      "search_query": "apartments near saddler's woods camden county",
      "category": "Park",
      "h1_title": "Apartments Near Saddler's Woods",
      "h2_subtitle": "Explore Fox Pointe's apartments near Saddler's Woods in Camden County. Enjoy tranquil living and a welcoming community.",
      "page_copy": "Situated in the heart of Camden County, Fox Pointe provides exquisite apartment living near the lush landscape of Saddler's Woods. If you appreciate the beauty of nature and outdoor exploration, our community offers the perfect backdrop for a fulfilling lifestyle.\n\nFox Pointe's modern amenities include a fitness center, swimming pool, and pet-friendly spaces, ensuring that your lifestyle needs are met. Apartments come ready with stackable washers and dryers, cable and satellite readiness, and flexible rent payment options. Experience comfort and enjoy the natural surroundings at Fox Pointe, minutes away from the serene Saddler's Woods.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Saddler's Woods Camden County",
      "seo_description": "Discover Fox Pointe's apartments near Saddler's Woods in Camden County. Enjoy nature's tranquility alongside modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "living-near-crystal-springs-park-hi-nella-nj-156",
      "search_query": "living near crystal springs park hi nella nj",
      "category": "Park",
      "h1_title": "Living Near Crystal Springs Park",
      "h2_subtitle": "Experience Fox Pointe living near Crystal Springs Park in Hi-Nella, NJ. Enjoy nature and community amenities.",
      "page_copy": "Fox Pointe in Hi-Nella, NJ offers a premier living experience just moments from the tranquil Crystal Springs Park. Our community is perfect for those who value proximity to beautiful outdoor spaces for relaxation and recreation.\n\nResidents enjoy access to a variety of amenities including a fitness center, swimming pool, and areas to entertain, such as a picnic area. Apartments are designed with stackable washers and dryers, are cable and satellite ready, and offer the convenience of flex rent payments. Enjoy the balance of modern living and natural beauty at Fox Pointe near Crystal Springs Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Crystal Springs Park Hi-Nella, NJ",
      "seo_description": "Fox Pointe offers modern living near Crystal Springs Park in Hi-Nella, NJ. Enjoy outdoor serenity and a range of amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "fox-pointe-nearby-lindenwold-memorial-park-916",
      "search_query": "fox pointe nearby lindenwold memorial park",
      "category": "Park",
      "h1_title": "Fox Pointe Near Lindenwold Memorial Park",
      "h2_subtitle": "Discover Fox Pointe, conveniently located near Lindenwold Memorial Park. Enjoy community amenities and nearby outdoor spaces.",
      "page_copy": "Located just a short distance from Lindenwold Memorial Park, Fox Pointe in Hi-Nella, NJ, offers residents a blend of modern comfort and natural beauty. This proximity ensures endless opportunities for leisurely strolls, picnics, and enjoying the outdoors, all just a stone's throw from your doorstep.\n\nExperience seamless living at Fox Pointe with amenities such as a fitness center, swimming pool, and picnic areas. Our apartments feature modern conveniences like stackable washers and dryers, with options for cable and satellite connectivity. Embrace the balanced lifestyle offered by Fox Pointe, where the serenity of nearby Lindenwold Memorial Park meets exceptional living standards.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fox Pointe Near Lindenwold Memorial Park",
      "seo_description": "Fox Pointe offers convenient living near Lindenwold Memorial Park. Enjoy amenities alongside nature in Hi-Nella, NJ.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "apartments-close-to-cooper-river-park-camden-county-212",
      "search_query": "apartments close to cooper river park camden county",
      "category": "Park",
      "h1_title": "Apartments Close to Cooper River Park",
      "h2_subtitle": "Fox Pointe offers apartments close to Cooper River Park in Camden County. Enjoy easy access to outdoor activities and community living.",
      "page_copy": "Nestled in Hi-Nella, NJ, Fox Pointe offers the perfect apartments close to Cooper River Park, a haven for outdoor enthusiasts in Camden County. Residents enjoy the luxury of living just a short drive away from this expansive park, known for its scenic trails and recreational activities.\n\nAt Fox Pointe, the focus is on providing a vibrant community with modern amenities, including a fitness center, swimming pool, and community events. Each apartment is equipped with a stackable washer and dryer set and is cable and satellite ready, allowing you to enjoy comfort and convenience. Fox Pointe's location near Cooper River Park places you in the heart of a beautiful, active community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Cooper River Park Camden County",
      "seo_description": "Fox Pointe offers apartments close to Cooper River Park, Camden County. Enjoy nature and modern amenities for an active lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "apartments-near-woodcrest-transit-station-hi-nella-835",
      "search_query": "apartments near Woodcrest Transit Station Hi-Nella",
      "category": "Transit",
      "h1_title": "Apartments Near Woodcrest Transit Station",
      "h2_subtitle": "Find convenient living at Fox Pointe, near Woodcrest Transit Station. Enjoy easy commutes and community amenities in Hi-Nella.",
      "page_copy": "Fox Pointe in Hi-Nella, NJ offers an ideal location for those seeking apartments near Woodcrest Transit Station. This makes commuting a breeze, connecting you effortlessly to the wider Camden County area and beyond.\n\nLiving at Fox Pointe means enjoying modern comforts with amenities like a fitness center, swimming pool, and community events that create a vibrant living environment. With pet-friendly policies and luxurious conveniences such as in-unit stackable washers and dryers, as well as cable and satellite readiness, you'll find that Fox Pointe uniquely blends convenience with contemporary living. Perfectly situated, you can enjoy the ease of public transit while residing in a welcoming community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Woodcrest Transit Station",
      "seo_description": "Fox Pointe offers convenient apartments near Woodcrest Transit Station in Hi-Nella. Enjoy easy commuting and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "fox-pointe-apartments-close-to-ferry-avenue-camden-county-188",
      "search_query": "Fox Pointe apartments close to Ferry Avenue Camden County",
      "category": "Transit",
      "h1_title": "Fox Pointe Near Ferry Avenue",
      "h2_subtitle": "Explore Fox Pointe Apartments close to Ferry Avenue in Camden County. Enjoy both commuting convenience and luxury living in Hi-Nella.",
      "page_copy": "Fox Pointe Apartments in Hi-Nella, NJ, offer residents a prime location close to Ferry Avenue, a key area in Camden County ideal for both commuters and explorers. Easy accessibility to public transportation and major highways makes living here convenient for daily travel.\n\nOur community is designed with your lifestyle in mind, offering amenities such as a fitness center, swimming pool, and picnic areas. Each apartment is ready with essential conveniences including stackable washers and dryers and cable/satellite options. Fox Pointe combines ease of access with richly appointed living spaces, making it the perfect home base near Ferry Avenue.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fox Pointe Near Ferry Avenue Camden County",
      "seo_description": "Discover Fox Pointe, close to Ferry Avenue in Camden County. Enjoy modern living with easy commutes and top amenities in Hi-Nella.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166315",
      "source": "custom",
      "page_item_url": "hi-nella-apartments-accessible-to-philadelphia-airport-745",
      "search_query": "Hi-Nella apartments with easy access to Philadelphia International Airport",
      "category": "Transit",
      "h1_title": "Hi-Nella Apartments Near Philadelphia Airport",
      "h2_subtitle": "Discover Fox Pointe, offering Hi-Nella apartments with easy access to Philadelphia International Airport. Ideal for frequent travelers.",
      "page_copy": "At Fox Pointe in Hi-Nella, NJ, you'll find apartments that provide straightforward access to Philadelphia International Airport, making it an excellent choice for frequent flyers. Located conveniently within Camden County, our community ensures that traveling to and from the airport is hassle-free, while granting you a peaceful home setting.\n\nOur apartments offer a myriad of amenities, including a modern fitness center, inviting swimming pool, and community events that foster a strong community spirit. Each home comes equipped with stackable washers and dryers and is cable and satellite ready, ensuring comfort and convenience. Fox Pointe blends easy accessibility with exceptional living spaces, perfect for those who value both travel convenience and luxurious living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of brick apartment buildings with white doors and windows.",
        "public_id": "019fcdf4-e4f2-715d-83a4-ae66e451ee6e",
        "storage_key": "property/6767906449166315/019fcdf4-e4f2-715d-83a4-ae66e451ee6e.webp",
        "width": 1920,
        "height": 1278
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hi-Nella Apartments Near Philadelphia Airport",
      "seo_description": "Conveniently located, Fox Pointe offers Hi-Nella apartments with easy access to Philadelphia International Airport. Ideal for travelers.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5053"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976240377"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973275"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5SS9SXPP"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://livefoxpointe.fatwin.com/api/websites/resources/1?x=TDB3TXAvOEF3N1ZPNXhzaGU0ODU1UUc4MXFtY2NPeXlsbzQ2NW5QeHFvL3Y3NGJyeUo5cklieTVCWUNMNHZxTUU3RUU4QTdYVTFucVgrQXFOWExkWHc9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/5evek7e1vqo"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "9549ceb4-43e6-11ef-860c-bf274ab37a10"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549ceb4-43e6-11ef-860c-bf274ab37a10/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549ceb4-43e6-11ef-860c-bf274ab37a10/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImFXUDJXWTFTbWE3K0pBVlAzTlJjd0E9PSIsInZhbHVlIjoiWGFhTWl2elFhQTdWZ2I1YVdLaTlRdz09IiwibWFjIjoiY2Y2OTkzOTUzYzEwYWMzYzNiMmE0YTMxYjJjMGE5OWM3NThmZjllMzU2MjM5MGI0MDUyMzdkZDk3MzA0MTMzOCJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5053",
  "custom_repli_id": "9976240377",
  "custom_realpage_id": "4973275",
  "custom_google_gtm_id": "GTM-5SS9SXPP",
  "custom_perq_script_url": "https://livefoxpointe.fatwin.com/api/websites/resources/1?x=TDB3TXAvOEF3N1ZPNXhzaGU0ODU1UUc4MXFtY2NPeXlsbzQ2NW5QeHFvL3Y3NGJyeUo5cklieTVCWUNMNHZxTUU3RUU4QTdYVTFucVgrQXFOWExkWHc9PQ2",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/5evek7e1vqo",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "9549ceb4-43e6-11ef-860c-bf274ab37a10",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549ceb4-43e6-11ef-860c-bf274ab37a10/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9549ceb4-43e6-11ef-860c-bf274ab37a10/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImFXUDJXWTFTbWE3K0pBVlAzTlJjd0E9PSIsInZhbHVlIjoiWGFhTWl2elFhQTdWZ2I1YVdLaTlRdz09IiwibWFjIjoiY2Y2OTkzOTUzYzEwYWMzYzNiMmE0YTMxYjJjMGE5OWM3NThmZjllMzU2MjM5MGI0MDUyMzdkZDk3MzA0MTMzOCJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "80e24ed0-91a5-4e7f-b15f-65359b744980",
  "custom_audioeye_site_hash": "d9dc87b933f3aba65e4d07f25227db6d"
};

export const generatedAt = '2026-10-22T20:07:39.250Z';
